function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from "react";
import { Field, Form as FormikForm, Formik } from "formik";
import { UserContext, FilterContext } from "../index";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import classNames from "classnames";
import "./LeaveSettings.css";
import Modal from "react-bootstrap/Modal";
import FormGroup from "react-bootstrap/FormGroup";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import { MdDeleteForever, MdModeEdit, MdArchive, MdUnarchive, MdMoneyOff } from "react-icons/md";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ADD_LEAVE_TYPE_MUTATION, EDIT_LEAVE_TYPE_MUTATION, LEAVE_SETTINGS_LIST_QUERY, DELETE_LEAVE_TYPES_MUTATION, ADD_LEAVE_STATUS_CHANGE_USER_MUTATION, REMOVE_LEAVE_APPROVER_MUTATION, LEAVE_SETTINGS_APPROVED_LIST_QUERY, GET_LEAVE_USER_LISTING_QUERY, UPDATE_LEAVE_TYPE_STATUS_MUTATION, LEAVE_TYPE_ARCHIVED_LIST_QUERY, UPDATE_LEAVE_SETTINGS_MUTATION, UPDATE_LEAVE_PERMISSION_SETTINGS_MUTATION, LEAVE_TYPE_LIST_COUNT_QUERY, ADD_PERMISSION_DETAILS_MUTATION, PERMISSION_SETTINGS_LIST_QUERY, EDIT_PERMISSION_DETAILS_MUTATION, DELETE_PERMISSION_DETAILS_MUTATION, UPDATE_PERMISSION_STATUS_MUTATION, PERMISSION_ARCHIVED_SETTINGS_LIST_QUERY, ADD_USER_LEAVE_TYPE_MUTATION, EDIT_LEAVE_BALANCE_MUTATION, EDIT_CARRY_FORWARD_MUTATION, EDIT_LEAVE_MEMBER_MUTATION, LEAVE_ACTIVITY_SUMMARY_QUERY } from "./query";
import { toast } from "react-toastify";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import Select from "react-select";
import * as Yup from "yup";
import Loader from "./../Loader/Loader";
import Form from "react-bootstrap/Form";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { VscLoading, VscClose } from "react-icons/vsc";
import Table from "react-bootstrap/Table";
import { GoEye } from "react-icons/go";
import Accordion from "react-bootstrap/Accordion";
import { HiLockClosed } from "react-icons/hi";
import SearchBar from "../SearchBar";
import { GET_USER_LISTING_QUERY } from "./../MonthlyAttendance/query";
import { BsEyeFill, BsPeopleFill } from "react-icons/bs";
import { FiCalendar, FiSlash, FiCheck, FiLock, FiUnlock, FiDollarSign, FiUsers } from "react-icons/fi";
import { BsArrowLeftRight, BsPerson, BsClock } from "react-icons/bs";
import { ORGANISATION_TEAMS_QUERY } from "./../Employees/query";
import moment from "moment-timezone";
var TASK_ACTIVITY_LIMIT = 20;
import AdminViewLeave, { LeaveManagementEnableFeature } from "./../AdminViewLeave/AdminViewLeave";
import { use } from "react";
var LeaveTypesSchema = Yup.object().shape({
  leaveTypes: Yup.string().trim().required("Required").matches(/^[0-9a-zA-Z\s-&.(),]*$/, "We support alphanumeric and (.,-&) symbols only")
  //leaveTypeDaysCount: Yup.string().trim().required("Required"),
});
var permissionSchema = Yup.object().shape({
  //permissionName: Yup.string().trim().required("Required"),
  totalTime: Yup.number().positive().min(0, "only positive value").required("Required")
});
var LIMIT = 20;
var LeaveSettings = function LeaveSettings(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    role = _React$useContext2.role,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from,
    organisationSettings = _React$useContext2.organisationSettings,
    leaveSettingsUser = _React$useContext2.leaveSettingsUser,
    organisationStatus = _React$useContext2.organisationStatus;

  //load more
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isAllLoaded = _React$useState2[0],
    setIsAllLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isLoadingMore = _React$useState4[0],
    setIsLoadingMore = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isLoadMoreButton = _React$useState6[0],
    setIsLoadMoreButton = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isAllLoadedArchived = _React$useState8[0],
    setIsAllLoadedArchived = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadingMoreArchived = _React$useState10[0],
    setIsLoadingMoreArchived = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoadMoreButtonArchived = _React$useState12[0],
    setIsLoadMoreButtonArchived = _React$useState12[1];

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var leaveSettingsCheckForUser = leaveSettingsUser && leaveSettingsUser !== null && leaveSettingsUser !== void 0 && leaveSettingsUser.approvedList.length ? leaveSettingsUser === null || leaveSettingsUser === void 0 ? void 0 : leaveSettingsUser.approvedList.find(function (o) {
    return o.userId === user.userId;
  }) : null;
  React.useEffect(function () {
    if (from == "web" && (role == "Member" || role == "Head") && !leaveSettingsCheckForUser && role != "Admin") {
      if (role == "Member") {
        props === null || props === void 0 ? void 0 : props.history.push("/my-work");
      } else {
        props === null || props === void 0 ? void 0 : props.history.push("/overview");
      }
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _useQuery = useQuery(GET_LEAVE_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery.loading,
    userListData = _useQuery.data,
    userListError = _useQuery.error,
    userRefetch = _useQuery.refetch;
  var _useQuery2 = useQuery(LEAVE_TYPE_LIST_COUNT_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    leaveTypeListCountData = _useQuery2.data,
    leaveTypeListCountError = _useQuery2.error,
    leaveTypeListCountLoading = _useQuery2.loading,
    countRefetch = _useQuery2.refetch;
  var _useQuery3 = useQuery(LEAVE_SETTINGS_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        limit: LIMIT,
        offset: 0
      },
      skip: !organisationId,
      fetchPolicy: "cache-first"
    }),
    leaveSettingsLoading = _useQuery3.loading,
    leaveSettingsData = _useQuery3.data,
    leaveSettingsError = _useQuery3.error,
    settingRefetch = _useQuery3.refetch,
    fetchMore = _useQuery3.fetchMore;
  var _useQuery4 = useQuery(LEAVE_SETTINGS_APPROVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    leaveSettingsApprovedLoading = _useQuery4.loading,
    leaveSettingsApprovedData = _useQuery4.data,
    leaveSettingsApprovedError = _useQuery4.error;
  React.useEffect(function () {
    userRefetch === null || userRefetch === void 0 ? void 0 : userRefetch();
    settingRefetch === null || settingRefetch === void 0 ? void 0 : settingRefetch();
    countRefetch === null || countRefetch === void 0 ? void 0 : countRefetch();
  }, [props.location.key]);
  React.useEffect(function () {
    var _leaveSettingsData$le, _leaveSettingsData$le2;
    setIsAllLoaded((leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le === void 0 ? void 0 : _leaveSettingsData$le.length) != 0 && (leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le2 = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le2 === void 0 ? void 0 : _leaveSettingsData$le2.length) < LIMIT && !isAllLoaded ? true : false);
  }, [leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : leaveSettingsData.leaveSettingsList]);
  var handleLoadMore = function handleLoadMore() {
    var _leaveSettingsData$le3;
    if (leaveSettingsLoading) return;
    setIsLoadingMore(true);
    fetchMore({
      variables: {
        offset: leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le3 = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le3 === void 0 ? void 0 : _leaveSettingsData$le3.length
      },
      updateQuery: function updateQuery(prev, _ref) {
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveSettingsList.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveSettingsList.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveSettingsList.length) > 0) {
          var NewFilterData = [];
          fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveSettingsList.forEach(function (newLeave) {
            var found = prev === null || prev === void 0 ? void 0 : prev.leaveSettingsList.find(function (item) {
              return item.leaveTypeId === newLeave.leaveTypeId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newLeave);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            leaveSettingsList: [].concat(_toConsumableArray(prev.leaveSettingsList), NewFilterData)
          });
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !organisationSettings.leaveManagementFeature && organisationSettings.leaveManagementFeature !== undefined ? /*#__PURE__*/React.createElement(LeaveManagementEnableFeature, {
    displayName: user === null || user === void 0 ? void 0 : user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history,
    role: role
  }) : /*#__PURE__*/React.createElement(AddLeaveTypes, {
    userListLoading: userListLoading,
    userListData: userListData,
    userId: user.userId,
    organisationId: organisationId,
    leaveSettingsLoading: leaveSettingsLoading,
    leaveSettingsError: leaveSettingsError,
    leaveSettingsData: leaveSettingsData,
    leaveSettingsCheckForUser: leaveSettingsCheckForUser,
    role: role,
    type: "add",
    leaveSettingsApprovedLoading: leaveSettingsApprovedLoading,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    leaveSettingsApprovedError: leaveSettingsApprovedError,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    handleLoadMore: handleLoadMore,
    settingRefetch: settingRefetch,
    isAllLoadedArchived: isAllLoadedArchived,
    setIsAllLoadedArchived: setIsAllLoadedArchived,
    isLoadingMoreArchived: isLoadingMoreArchived,
    setIsLoadingMoreArchived: setIsLoadingMoreArchived,
    isLoadMoreButtonArchived: isLoadMoreButtonArchived,
    setIsLoadMoreButtonArchived: setIsLoadMoreButtonArchived,
    leaveTypeListCountData: leaveTypeListCountData,
    leaveTypeListCountError: leaveTypeListCountError,
    leaveTypeListCountLoading: leaveTypeListCountLoading,
    countRefetch: countRefetch,
    timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
    location: props.location.key,
    teamId: teamId
  }));
};
export var leaveTypeList = ["Casual Leave", "Sick Leave", "Casual/Vacation Leave", "Paid Leave", "UnPaid Leave", "Compensatory Leave"];
var AddLeaveTypes = function AddLeaveTypes(props) {
  var userListLoading = props.userListLoading,
    userListData = props.userListData,
    userId = props.userId,
    organisationId = props.organisationId,
    leaveSettingsLoading = props.leaveSettingsLoading,
    leaveSettingsError = props.leaveSettingsError,
    leaveSettingsData = props.leaveSettingsData,
    leaveSettingsCheckForUser = props.leaveSettingsCheckForUser,
    role = props.role,
    type = props.type,
    leaveSettingsApprovedLoading = props.leaveSettingsApprovedLoading,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    leaveSettingsApprovedError = props.leaveSettingsApprovedError,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    settingRefetch = props.settingRefetch,
    isAllLoadedArchived = props.isAllLoadedArchived,
    setIsAllLoadedArchived = props.setIsAllLoadedArchived,
    isLoadingMoreArchived = props.isLoadingMoreArchived,
    setIsLoadingMoreArchived = props.setIsLoadingMoreArchived,
    isLoadMoreButtonArchived = props.isLoadMoreButtonArchived,
    setIsLoadMoreButtonArchived = props.setIsLoadMoreButtonArchived,
    leaveTypeListCountData = props.leaveTypeListCountData,
    leaveTypeListCountError = props.leaveTypeListCountError,
    leaveTypeListCountLoading = props.leaveTypeListCountLoading,
    countRefetch = props.countRefetch,
    timeZone = props.timeZone,
    location = props.location,
    teamId = props.teamId;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    leaveTypeModalShow = _useState2[0],
    setleaveTypeShow = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    leaveTypeModalEditShow = _useState4[0],
    setleaveTypeEditShow = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    leaveTypeModalDeleteShow = _useState6[0],
    setleaveTypeDeleteShow = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    leaveTypeModalArchiveShow = _useState8[0],
    setleaveTypeArchiveShow = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    leaveTypeEditList = _useState10[0],
    setLeaveTypeEditList = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    leaveTypeDeleteList = _useState12[0],
    setLeaveTypeDeleteList = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    leaveTypeArchiveList = _useState14[0],
    setLeaveTypeArchiveList = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    leaveTypeUnArchiveList = _useState16[0],
    setLeaveTypeUnArchiveList = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    leaveTypeViewShow = _useState18[0],
    setleaveTypeViewShow = _useState18[1];
  var handleLeaveTypeClose = function handleLeaveTypeClose() {
    setleaveTypeShow(null);
  };
  var handleLeaveTypeShow = function handleLeaveTypeShow() {
    setleaveTypeShow(true);
  };
  var handleLeaveTypeEditClose = function handleLeaveTypeEditClose() {
    setleaveTypeEditShow(null);
  };
  var handleLeaveTypeEditShow = function handleLeaveTypeEditShow(list) {
    setleaveTypeEditShow(list);
  };
  var handleLeaveTypeDeleteClose = function handleLeaveTypeDeleteClose() {
    setleaveTypeDeleteShow(null);
  };
  var handleLeaveTypeDeleteShow = function handleLeaveTypeDeleteShow(list) {
    setleaveTypeDeleteShow(list);
  };
  var handleLeaveTypeArchiveClose = function handleLeaveTypeArchiveClose() {
    setleaveTypeArchiveShow(null);
  };
  var handleLeaveTypeArchiveShow = function handleLeaveTypeArchiveShow(list) {
    setleaveTypeArchiveShow(list);
  };
  var handleLeaveTypeViewClose = function handleLeaveTypeViewClose() {
    setleaveTypeViewShow(null);
  };
  var handleLeaveTypeViewShow = function handleLeaveTypeViewShow(list) {
    setleaveTypeViewShow(list);
  };
  var _useLazyQuery = useLazyQuery(LEAVE_TYPE_ARCHIVED_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        limit: LIMIT,
        offset: 0
      },
      skip: !organisationId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getLeaveTypeArchivedData = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    leaveArchivedLoading = _useLazyQuery2$.loading,
    leaveArchivedData = _useLazyQuery2$.data,
    leaveArchivedError = _useLazyQuery2$.error,
    archiveFetchMore = _useLazyQuery2$.fetchMore,
    archivedRefetch = _useLazyQuery2$.refetch;
  React.useEffect(function () {
    var _leaveArchivedData$le, _leaveArchivedData$le2;
    setIsAllLoadedArchived((leaveArchivedData === null || leaveArchivedData === void 0 ? void 0 : (_leaveArchivedData$le = leaveArchivedData.leaveTypeArchivedList) === null || _leaveArchivedData$le === void 0 ? void 0 : _leaveArchivedData$le.length) != 0 && (leaveArchivedData === null || leaveArchivedData === void 0 ? void 0 : (_leaveArchivedData$le2 = leaveArchivedData.leaveTypeArchivedList) === null || _leaveArchivedData$le2 === void 0 ? void 0 : _leaveArchivedData$le2.length) < LIMIT && !isAllLoaded ? true : false);
  }, [leaveArchivedData === null || leaveArchivedData === void 0 ? void 0 : leaveArchivedData.leaveTypeArchivedList]);
  var handleLoadMoreArchive = function handleLoadMoreArchive() {
    var _leaveArchivedData$le3;
    if (leaveArchivedLoading) return;
    setIsLoadingMoreArchived(true);
    archiveFetchMore({
      variables: {
        offset: leaveArchivedData === null || leaveArchivedData === void 0 ? void 0 : (_leaveArchivedData$le3 = leaveArchivedData.leaveTypeArchivedList) === null || _leaveArchivedData$le3 === void 0 ? void 0 : _leaveArchivedData$le3.length
      },
      updateQuery: function updateQuery(prev, _ref2) {
        var fetchMoreResult = _ref2.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveTypeArchivedList.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveTypeArchivedList.length) < LIMIT && !isAllLoaded) {
          setIsAllLoadedArchived(true);
        }
        setIsLoadingMoreArchived(false);
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveTypeArchivedList.length) > 0) {
          var NewFilterData = [];
          fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.leaveTypeArchivedList.forEach(function (newLeave) {
            var found = prev === null || prev === void 0 ? void 0 : prev.leaveTypeArchivedList.find(function (item) {
              return item.leaveTypeId === newLeave.leaveTypeId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newLeave);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            leaveTypeArchivedList: [].concat(_toConsumableArray(prev.leaveTypeArchivedList), NewFilterData)
          });
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-card"
  }, /*#__PURE__*/React.createElement(LeaveTypeList, {
    handleLeaveTypeShow: handleLeaveTypeShow,
    leaveSettingsLoading: leaveSettingsLoading,
    leaveSettingsError: leaveSettingsError,
    leaveSettingsData: leaveSettingsData,
    leaveTypeDeleteList: leaveTypeDeleteList,
    leaveTypeEditList: leaveTypeEditList,
    handleLeaveTypeArchiveShow: handleLeaveTypeArchiveShow,
    handleLeaveTypeEditShow: handleLeaveTypeEditShow,
    handleLeaveTypeDeleteShow: handleLeaveTypeDeleteShow,
    getLeaveTypeArchivedData: getLeaveTypeArchivedData,
    leaveArchivedLoading: leaveArchivedLoading,
    leaveArchivedData: leaveArchivedData,
    leaveArchivedError: leaveArchivedError,
    leaveTypeArchiveList: leaveTypeArchiveList,
    leaveTypeUnArchiveList: leaveTypeUnArchiveList,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    handleLoadMore: handleLoadMore,
    settingRefetch: settingRefetch,
    isAllLoadedArchived: isAllLoadedArchived,
    setIsAllLoadedArchived: setIsAllLoadedArchived,
    isLoadingMoreArchived: isLoadingMoreArchived,
    setIsLoadingMoreArchived: setIsLoadingMoreArchived,
    isLoadMoreButtonArchived: isLoadMoreButtonArchived,
    setIsLoadMoreButtonArchived: setIsLoadMoreButtonArchived,
    handleLoadMoreArchive: handleLoadMoreArchive,
    archivedRefetch: archivedRefetch,
    leaveTypeListCountData: leaveTypeListCountData,
    leaveTypeListCountError: leaveTypeListCountError,
    leaveTypeListCountLoading: leaveTypeListCountLoading,
    countRefetch: countRefetch,
    handleLeaveTypeViewShow: handleLeaveTypeViewShow
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-grid"
  }, role == "Admin" || !leaveSettingsCheckForUser && role != "Admin" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-grid-card-list-div"
  }, /*#__PURE__*/React.createElement(LeaveStatusChange, {
    userListLoading: userListLoading,
    userListData: userListData,
    organisationId: organisationId,
    leaveSettingsApprovedLoading: leaveSettingsApprovedLoading,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    leaveSettingsApprovedError: leaveSettingsApprovedError
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-group-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-grid-card"
  }, /*#__PURE__*/React.createElement(LeavePermission, {
    organisationId: organisationId,
    userId: userId,
    timeZone: timeZone,
    location: location
  })), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-grid-card"
  }, /*#__PURE__*/React.createElement(LeaveYearSettings, {
    organisationId: organisationId,
    leaveSettingsApprovedLoading: leaveSettingsApprovedLoading,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    leaveSettingsApprovedError: leaveSettingsApprovedError
  }))), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-grid-card"
  }, leaveSettingsApprovedLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(LeavePermissionSettings, {
    organisationId: organisationId,
    leaveSettingsApprovedLoading: leaveSettingsApprovedLoading,
    leaveSettingsApprovedData: leaveSettingsApprovedData,
    leaveSettingsApprovedError: leaveSettingsApprovedError
  }))), /*#__PURE__*/React.createElement(LeaveTypeModal, {
    leaveTypeModalShow: leaveTypeModalShow,
    handleLeaveTypeClose: handleLeaveTypeClose,
    userId: userId,
    organisationId: organisationId,
    role: role,
    teamId: teamId
  }), /*#__PURE__*/React.createElement(LeaveTypeModalEdit, {
    leaveTypeModalEditShow: leaveTypeModalEditShow,
    handleLeaveTypeEditClose: handleLeaveTypeEditClose,
    userId: userId,
    organisationId: organisationId,
    leaveTypeEditList: leaveTypeEditList,
    setLeaveTypeEditList: setLeaveTypeEditList
  }), /*#__PURE__*/React.createElement(DeleteConfirmation, {
    leaveTypeModalDeleteShow: leaveTypeModalDeleteShow,
    handleLeaveTypeDeleteClose: handleLeaveTypeDeleteClose,
    leaveTypeDeleteList: leaveTypeDeleteList,
    setLeaveTypeDeleteList: setLeaveTypeDeleteList,
    organisationId: organisationId
  }), /*#__PURE__*/React.createElement(ArchiveLeaveConfirmation, {
    handleLeaveTypeArchiveClose: handleLeaveTypeArchiveClose,
    handleLeaveTypeArchiveShow: handleLeaveTypeArchiveShow,
    setleaveTypeArchiveShow: setleaveTypeArchiveShow,
    leaveTypeArchiveList: leaveTypeArchiveList,
    setLeaveTypeArchiveList: setLeaveTypeArchiveList,
    organisationId: organisationId,
    leaveTypeModalArchiveShow: leaveTypeModalArchiveShow,
    leaveTypeUnArchiveList: leaveTypeUnArchiveList,
    setLeaveTypeUnArchiveList: setLeaveTypeUnArchiveList
  }), /*#__PURE__*/React.createElement(ViewDetailsModal, {
    leaveTypeViewShow: leaveTypeViewShow,
    handleLeaveTypeViewClose: handleLeaveTypeViewClose,
    organisationId: organisationId
  }));
};
var LeavePermission = function LeavePermission(props) {
  var _permissionData$permi4, _permissionData$permi6, _permissionData$permi7;
  var organisationId = props.organisationId,
    userId = props.userId,
    timeZone = props.timeZone,
    location = props.location;
  var _useState19 = useState(null),
    _useState20 = _slicedToArray(_useState19, 2),
    leavePermissionModalShow = _useState20[0],
    setleavePermissionShow = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    permissionModalEditShow = _useState22[0],
    setPermissionEditShow = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    permissionModalDeleteShow = _useState24[0],
    setPermissionDeleteShow = _useState24[1];
  var _useState25 = useState(null),
    _useState26 = _slicedToArray(_useState25, 2),
    permissionModalArchiveShow = _useState26[0],
    setPermissionArchiveShow = _useState26[1];
  var _React$useState13 = React.useState(null),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    showPermissionDetailModal = _React$useState14[0],
    setShowPermissionDetailModal = _React$useState14[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    permissionModalArchiveListShow = _useState28[0],
    setPermissionArchiveListShow = _useState28[1];

  //load more
  var _React$useState15 = React.useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    isAllLoaded = _React$useState16[0],
    setIsAllLoaded = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    isLoadingMore = _React$useState18[0],
    setIsLoadingMore = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isLoadMoreButton = _React$useState20[0],
    setIsLoadMoreButton = _React$useState20[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    permissionEditList = _useState30[0],
    setPermissionEditList = _useState30[1];
  var _useState31 = useState([]),
    _useState32 = _slicedToArray(_useState31, 2),
    permissionDeleteList = _useState32[0],
    setPermissionDeleteList = _useState32[1];
  // const [permissionArchiveList, setPermissionArchiveList] = useState([]);
  // const [permissionUnArchiveList, setPermissionUnArchiveList] = useState([]);

  var _useQuery5 = useQuery(PERMISSION_SETTINGS_LIST_QUERY, {
      variables: {
        organisationId: organisationId,
        limit: LIMIT,
        offset: 0
      },
      skip: !organisationId
    }),
    permissionLoading = _useQuery5.loading,
    permissionData = _useQuery5.data,
    permissionError = _useQuery5.error,
    permissionRefetch = _useQuery5.refetch,
    fetchMore = _useQuery5.fetchMore;
  React.useEffect(function () {
    permissionRefetch === null || permissionRefetch === void 0 ? void 0 : permissionRefetch();
  }, [location]);
  React.useEffect(function () {
    var _permissionData$permi, _permissionData$permi2;
    setIsAllLoaded((permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi = permissionData.permissionList) === null || _permissionData$permi === void 0 ? void 0 : _permissionData$permi.length) != 0 && (permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi2 = permissionData.permissionList) === null || _permissionData$permi2 === void 0 ? void 0 : _permissionData$permi2.length) < LIMIT && !isAllLoaded ? true : false);
  }, [permissionData === null || permissionData === void 0 ? void 0 : permissionData.permissionList]);
  var handleLeavePermissionShow = function handleLeavePermissionShow() {
    setleavePermissionShow(true);
  };
  var handleLeavePermissionClose = function handleLeavePermissionClose() {
    setleavePermissionShow(null);
  };
  var handlePermissionEditClose = function handlePermissionEditClose() {
    setPermissionEditShow(null);
  };
  var handlePermissionEditShow = function handlePermissionEditShow(list) {
    setPermissionEditShow(list);
  };
  var handlePermissionDeleteClose = function handlePermissionDeleteClose() {
    setPermissionDeleteShow(null);
  };
  var handlePermissionDeleteShow = function handlePermissionDeleteShow(list) {
    setPermissionDeleteShow(list);
  };
  var handlePermissionArchiveClose = function handlePermissionArchiveClose() {
    setPermissionArchiveShow(null);
  };
  var handlePermissionArchiveShow = function handlePermissionArchiveShow(list) {
    setPermissionArchiveShow(list);
  };
  var handleShowPermissionDetailDetails = function handleShowPermissionDetailDetails(list) {
    setShowPermissionDetailModal(list);
  };
  var handleClosePermissionDetailDetails = function handleClosePermissionDetailDetails() {
    setShowPermissionDetailModal(null);
  };

  // const handlePermissionArchiveListClose = () => {
  //   setPermissionArchiveListShow(null);
  // };

  // const handlePermissionArchiveListShow = () => {
  //   setPermissionArchiveListShow(true);
  // };

  var handleLoadMore = function handleLoadMore() {
    var _permissionData$permi3;
    if (permissionLoading) return;
    setIsLoadingMore(true);
    fetchMore({
      variables: {
        offset: permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi3 = permissionData.permissionList) === null || _permissionData$permi3 === void 0 ? void 0 : _permissionData$permi3.length
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.permissionList.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.permissionList.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.permissionList.length) > 0) {
          var NewFilterData = [];
          fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : fetchMoreResult.permissionList.forEach(function (newLeave) {
            var found = prev === null || prev === void 0 ? void 0 : prev.permissionList.find(function (item) {
              return item.permissionId === newLeave.permissionId;
            });
            if (!found) {
              // If not found, add validation.
              NewFilterData.push(newLeave);
            }
          });
          return _objectSpread(_objectSpread({}, prev), {}, {
            permissionList: [].concat(_toConsumableArray(prev.permissionList), NewFilterData)
          });
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "permission-row-grid-card-list-div leave-setting-type-card "
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-leave-type-label"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "leave-setting-row-color"
  }, "Short Leave"), " ", /*#__PURE__*/React.createElement("div", null, permissionLoading ? /*#__PURE__*/React.createElement("div", {
    className: "short-leave-loader"
  }, /*#__PURE__*/React.createElement(Loader, null)) : (permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi4 = permissionData.permissionList) === null || _permissionData$permi4 === void 0 ? void 0 : _permissionData$permi4.length) == 0 ? /*#__PURE__*/React.createElement("label", {
    className: "leave-settings-worked-days-list-form-label",
    onClick: function onClick() {
      return handleLeavePermissionShow();
    }
  }, "Enable Short Leave") : /*#__PURE__*/React.createElement("label", {
    className: "leave-settings-worked-days-list-form-label-disable",
    onClick: function onClick() {
      var _permissionData$permi5;
      return handlePermissionDeleteShow({
        permissionId: (permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi5 = permissionData.permissionList) === null || _permissionData$permi5 === void 0 ? void 0 : _permissionData$permi5.length) > 0 ? permissionData === null || permissionData === void 0 ? void 0 : permissionData.permissionList[0].permissionId : ""
      });
    }
  }, "Disable Short Leave"))), /*#__PURE__*/React.createElement("div", {
    className: " leave-settings-worked-days-list-form-group-type-permission"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-permission-card-table"
  }, permissionLoading ? /*#__PURE__*/React.createElement(Loader, null) : permissionError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong") : (permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi6 = permissionData.permissionList) === null || _permissionData$permi6 === void 0 ? void 0 : _permissionData$permi6.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "scheduled-reports-card-table-body"
  }, permissionData === null || permissionData === void 0 ? void 0 : (_permissionData$permi7 = permissionData.permissionList) === null || _permissionData$permi7 === void 0 ? void 0 : _permissionData$permi7.map(function (type) {
    var permissionId = type.permissionId,
      permissionName = type.permissionName,
      applicableWithin = type.applicableWithin,
      totalAllowedTime = type.totalAllowedTime;
    if (permissionDeleteList.length > 0 && permissionDeleteList.includes(permissionId)) {
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: permissionId,
      className: "leave-permission-card-table-data-details"
    }, /*#__PURE__*/React.createElement("div", {
      className: "permission-whole-div"
    }, /*#__PURE__*/React.createElement("div", {
      className: "permission-card-table-data-details-report-name "
    }, "Allowed Short Break: ", totalAllowedTime, " in a ", applicableWithin), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "leave-permission-width-option"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Edit this short leave type")
    }, /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        return handlePermissionEditShow(_objectSpread({}, type));
      },
      className: "edit-div-permission"
    }, /*#__PURE__*/React.createElement("span", {
      className: "leave-permission-worked-days-data-type-view-icon-span"
    }, "Edit")))))));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-no-data-text"
  }, "Yet to enable short leave.")))), /*#__PURE__*/React.createElement(LeavePermissionModal, {
    leavePermissionModalShow: leavePermissionModalShow,
    handleLeavePermissionClose: handleLeavePermissionClose,
    organisationId: organisationId,
    userId: userId,
    timeZone: timeZone
  }), /*#__PURE__*/React.createElement(PermissionModalEdit, {
    permissionModalEditShow: permissionModalEditShow,
    handlePermissionEditClose: handlePermissionEditClose,
    userId: userId,
    organisationId: organisationId,
    permissionEditList: permissionEditList,
    setPermissionEditList: setPermissionEditList
  }), /*#__PURE__*/React.createElement(PermissionDeleteConfirmation, {
    permissionModalDeleteShow: permissionModalDeleteShow,
    handlePermissionDeleteClose: handlePermissionDeleteClose,
    permissionDeleteList: permissionDeleteList,
    setPermissionDeleteList: setPermissionDeleteList,
    organisationId: organisationId,
    userId: userId
  }), /*#__PURE__*/React.createElement(PermissionDetailsModal, {
    showPermissionDetailModal: showPermissionDetailModal,
    setShowPermissionDetailModal: setShowPermissionDetailModal,
    handleShowPermissionDetailDetails: handleShowPermissionDetailDetails,
    handleClosePermissionDetailDetails: handleClosePermissionDetailDetails
  }));
};
var LeaveTypeList = function LeaveTypeList(props) {
  var _leaveTypeListCountDa, _leaveTypeListCountDa2, _leaveSettingsData$le4, _leaveSettingsData$le5, _leaveTypeListCountDa3, _leaveTypeListCountDa4, _leaveArchivedData$le4, _leaveArchivedData$le5;
  var handleLeaveTypeShow = props.handleLeaveTypeShow,
    leaveSettingsLoading = props.leaveSettingsLoading,
    leaveSettingsError = props.leaveSettingsError,
    leaveSettingsData = props.leaveSettingsData,
    leaveTypeDeleteList = props.leaveTypeDeleteList,
    leaveTypeEditList = props.leaveTypeEditList,
    handleLeaveTypeArchiveShow = props.handleLeaveTypeArchiveShow,
    handleLeaveTypeEditShow = props.handleLeaveTypeEditShow,
    handleLeaveTypeDeleteShow = props.handleLeaveTypeDeleteShow,
    getLeaveTypeArchivedData = props.getLeaveTypeArchivedData,
    leaveArchivedLoading = props.leaveArchivedLoading,
    leaveArchivedData = props.leaveArchivedData,
    leaveArchivedError = props.leaveArchivedError,
    leaveTypeArchiveList = props.leaveTypeArchiveList,
    leaveTypeUnArchiveList = props.leaveTypeUnArchiveList,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    settingRefetch = props.settingRefetch,
    isAllLoadedArchived = props.isAllLoadedArchived,
    setIsAllLoadedArchived = props.setIsAllLoadedArchived,
    isLoadingMoreArchived = props.isLoadingMoreArchived,
    setIsLoadingMoreArchived = props.setIsLoadingMoreArchived,
    isLoadMoreButtonArchived = props.isLoadMoreButtonArchived,
    setIsLoadMoreButtonArchived = props.setIsLoadMoreButtonArchived,
    handleLoadMoreArchive = props.handleLoadMoreArchive,
    archivedRefetch = props.archivedRefetch,
    leaveTypeListCountData = props.leaveTypeListCountData,
    leaveTypeListCountError = props.leaveTypeListCountError,
    leaveTypeListCountLoading = props.leaveTypeListCountLoading,
    countRefetch = props.countRefetch,
    handleLeaveTypeViewShow = props.handleLeaveTypeViewShow;
  var _React$useState21 = React.useState("leave-types"),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    activeTab = _React$useState22[0],
    setActiveTab = _React$useState22[1];
  React.useEffect(function () {
    if (activeTab == "archived") {
      getLeaveTypeArchivedData();
    }
  }, [activeTab]);
  React.useEffect(function () {
    setIsAllLoaded(false);
    settingRefetch === null || settingRefetch === void 0 ? void 0 : settingRefetch();
    archivedRefetch === null || archivedRefetch === void 0 ? void 0 : archivedRefetch();
    setIsAllLoadedArchived(false);
    countRefetch === null || countRefetch === void 0 ? void 0 : countRefetch();
  }, [activeTab]);
  return /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-grid-card-list-div "
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-leave-type-label"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "leave-setting-row-color"
  }, "Leave Type Settings"), " ", /*#__PURE__*/React.createElement("label", {
    className: "leave-settings-worked-days-list-form-label",
    onClick: function onClick() {
      return handleLeaveTypeShow();
    }
  }, "Add New Leave Type")), /*#__PURE__*/React.createElement("div", {
    className: " leave-settings-worked-days-list-form-group-type"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "leave-types",
    onSelect: function onSelect(e) {
      setActiveTab(e);
    },
    className: "leave-setting-filter-type-root-tab"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "leave-types",
    title: /*#__PURE__*/React.createElement("span", null, "Active Leave Types", " ", (leaveTypeListCountData === null || leaveTypeListCountData === void 0 ? void 0 : (_leaveTypeListCountDa = leaveTypeListCountData.leaveTypeListCount) === null || _leaveTypeListCountDa === void 0 ? void 0 : _leaveTypeListCountDa.leaveCount) != 0 && !leaveTypeListCountLoading && !leaveTypeListCountError ? "(".concat(leaveTypeListCountData === null || leaveTypeListCountData === void 0 ? void 0 : (_leaveTypeListCountDa2 = leaveTypeListCountData.leaveTypeListCount) === null || _leaveTypeListCountDa2 === void 0 ? void 0 : _leaveTypeListCountDa2.leaveCount, ")") : leaveTypeListCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-worked-days-list"
  }, leaveSettingsLoading ? /*#__PURE__*/React.createElement(Loader, null) : leaveSettingsError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong") : (leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le4 = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le4 === void 0 ? void 0 : _leaveSettingsData$le4.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-setting-type-header-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-setting-type-header-text-type"
  }, "Leave Type"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-allowed"
  }, "Allowed Days"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-cycle"
  }, "Leave Cycle"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-reset"
  }, "Carry Forward"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-reset"
  }, "Paid/Unpaid"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-cycle-visible"
  }, "Visibility"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-option"
  })), leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le5 = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le5 === void 0 ? void 0 : _leaveSettingsData$le5.map(function (type, index) {
    var _leaveSettingsData$le6, _leaveSettingsData$le7;
    if (leaveTypeDeleteList.length > 0 && leaveTypeDeleteList.includes(type === null || type === void 0 ? void 0 : type.leaveTypeId)) {
      return;
    }
    if (leaveTypeArchiveList.length > 0 && leaveTypeArchiveList.includes(type === null || type === void 0 ? void 0 : type.leaveTypeId)) {
      return;
    }
    var findLeaveEdit = leaveTypeEditList && leaveTypeEditList.find(function (leave) {
      return leave.leaveTypeId === type.leaveTypeId;
    }) || {};
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-settings-worked-days-data")
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, type === null || type === void 0 ? void 0 : type.leaveTypeName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-worked-days-data-type",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, findLeaveEdit && findLeaveEdit !== null && findLeaveEdit !== void 0 && findLeaveEdit.leaveTypeName ? findLeaveEdit === null || findLeaveEdit === void 0 ? void 0 : findLeaveEdit.leaveTypeName : type === null || type === void 0 ? void 0 : type.leaveTypeName)), /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-width-allowed"),
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveTypeCount, " ", type.leaveTypeCount || type.leaveTypeCount == 0 ? type.leaveTypeCount > 1 ? "days" : "day" : "Unlimited days"), /*#__PURE__*/React.createElement("div", {
      className: "leave-width-cycle",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.resetLeaveBalance ? type.resetLeaveBalance : "Annually"), /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-width-reset"),
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveCarryForward == "true" ? "Yes" : "No"), /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-width-reset"),
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveNature ? type.leaveNature == "Paid" ? "Paid Leave" : "Unpaid Leave" : "Paid Leave"), /*#__PURE__*/React.createElement("div", {
      className: "leave-width-cycle-visible",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveTypeVisibility == "private" ? "Selected Members" : " All Employees"), /*#__PURE__*/React.createElement("div", {
      className: "leave-width-option"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "View Details")
    }, /*#__PURE__*/React.createElement(BsEyeFill, {
      className: "leave-settings-worked-days-data-type-edit-icon-view",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    })), (leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le6 = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le6 === void 0 ? void 0 : _leaveSettingsData$le6.length) == 1 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Custom Leave Types need atleast one")
    }, /*#__PURE__*/React.createElement(MdArchive, {
      className: "leave-settings-worked-days-data-type-archive-icon"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Archive this leave type")
    }, /*#__PURE__*/React.createElement(MdArchive, {
      className: "leave-settings-worked-days-data-type-archive-icon",
      onClick: function onClick() {
        return handleLeaveTypeArchiveShow({
          leaveTypeId: type.leaveTypeId,
          status: "archived"
        });
      }
    })), /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Edit this leave type")
    }, /*#__PURE__*/React.createElement(MdModeEdit, {
      className: "leave-settings-worked-days-data-type-edit-icon",
      onClick: function onClick() {
        return handleLeaveTypeEditShow(_objectSpread({}, type));
      }
    })), (leaveSettingsData === null || leaveSettingsData === void 0 ? void 0 : (_leaveSettingsData$le7 = leaveSettingsData.leaveSettingsList) === null || _leaveSettingsData$le7 === void 0 ? void 0 : _leaveSettingsData$le7.length) == 1 ? /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Custom Leave Types need atleast one")
    }, /*#__PURE__*/React.createElement(MdDeleteForever, {
      className: "leave-settings-worked-days-data-type-delete-icon"
    })) : /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Delete this leave type")
    }, /*#__PURE__*/React.createElement(MdDeleteForever, {
      className: "leave-settings-worked-days-data-type-delete-icon",
      onClick: function onClick() {
        return handleLeaveTypeDeleteShow({
          leaveTypeId: type.leaveTypeId
        });
      }
    }))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "leave-type-setting-seen-all-data"
  }, "You have seen all the leave types"))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-no-data-text"
  }, "Yet to add leave types"))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "archived",
    title: /*#__PURE__*/React.createElement("span", null, "Archived Leaves", " ", (leaveTypeListCountData === null || leaveTypeListCountData === void 0 ? void 0 : (_leaveTypeListCountDa3 = leaveTypeListCountData.leaveTypeListCount) === null || _leaveTypeListCountDa3 === void 0 ? void 0 : _leaveTypeListCountDa3.archivedCount) != 0 && !leaveTypeListCountLoading && !leaveTypeListCountError ? "(".concat(leaveTypeListCountData === null || leaveTypeListCountData === void 0 ? void 0 : (_leaveTypeListCountDa4 = leaveTypeListCountData.leaveTypeListCount) === null || _leaveTypeListCountDa4 === void 0 ? void 0 : _leaveTypeListCountDa4.archivedCount, ")") : leaveTypeListCountLoading ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-worked-days-list"
  }, leaveArchivedLoading ? /*#__PURE__*/React.createElement(Loader, null) : leaveArchivedError ? /*#__PURE__*/React.createElement("div", null, "Something went wrong") : (leaveArchivedData === null || leaveArchivedData === void 0 ? void 0 : (_leaveArchivedData$le4 = leaveArchivedData.leaveTypeArchivedList) === null || _leaveArchivedData$le4 === void 0 ? void 0 : _leaveArchivedData$le4.length) > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-setting-type-header-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-setting-type-header-text-type"
  }, "Leave Type"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-allowed"
  }, "Allowed Days"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-cycle"
  }, "Leave Cycle"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-reset"
  }, "Carry Forward"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-reset"
  }, "Paid/Unpaid"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-cycle"
  }, "Visibility"), /*#__PURE__*/React.createElement("div", {
    className: "leave-width-option"
  })), leaveArchivedData === null || leaveArchivedData === void 0 ? void 0 : (_leaveArchivedData$le5 = leaveArchivedData.leaveTypeArchivedList) === null || _leaveArchivedData$le5 === void 0 ? void 0 : _leaveArchivedData$le5.map(function (type, index) {
    if (leaveTypeUnArchiveList.length > 0 && leaveTypeUnArchiveList.includes(type === null || type === void 0 ? void 0 : type.leaveTypeId)) {
      return;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-settings-worked-days-data")
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, type === null || type === void 0 ? void 0 : type.leaveTypeName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-worked-days-data-type",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type === null || type === void 0 ? void 0 : type.leaveTypeName)), /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-width-allowed"),
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveTypeCount, " ", type.leaveTypeCount ? type.leaveTypeCount > 1 ? "days" : "day" : "Unlimited days"), /*#__PURE__*/React.createElement("div", {
      className: "leave-width-cycle",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.resetLeaveBalance ? type.resetLeaveBalance : "Annually"), /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-width-reset"),
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveCarryForward == "true" ? "Yes" : "No"), /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-width-reset"),
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveNature ? type.leaveNature == "Paid" ? "Paid Leave" : "Unpaid Leave" : "Paid Leave"), /*#__PURE__*/React.createElement("div", {
      className: "leave-width-cycle-visible",
      onClick: function onClick() {
        return handleLeaveTypeViewShow(_objectSpread({}, type));
      }
    }, type.leaveTypeVisibility == "private" ? "Selected Members" : "All Employees"), /*#__PURE__*/React.createElement("div", {
      className: "leave-width-option"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "bottom",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "count-tooltip-start"
      }, "Unarchive this leave type")
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-worked-days-data-type-unarchived",
      onClick: function onClick() {
        return handleLeaveTypeArchiveShow({
          leaveTypeId: type.leaveTypeId,
          status: "unarchived"
        });
      }
    }, "Unarchive"))));
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-load-more-button"
  }, !isAllLoadedArchived ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreArchived && !isLoadMoreButtonArchived ? /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMoreArchive();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "leave-type-setting-seen-all-data"
  }, "You have seen all the archived leave types"))) : /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-no-data-text"
  }, "No archived leave types"))))));
};
var LeaveStatusChange = function LeaveStatusChange(props) {
  var _leaveSettingsApprove, _teamsData$organisati;
  var userListLoading = props.userListLoading,
    userListData = props.userListData,
    organisationId = props.organisationId,
    leaveSettingsApprovedLoading = props.leaveSettingsApprovedLoading,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData;
  var _React$useState23 = React.useState(null),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    selectedPerson = _React$useState24[0],
    setSelectedPerson = _React$useState24[1];
  var _React$useState25 = React.useState([{
      label: "All Teams (Global)",
      value: "all"
    }]),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    selectedTeam = _React$useState26[0],
    setSelectedTeam = _React$useState26[1];
  var _React$useState27 = React.useState(null),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    removingUserId = _React$useState28[0],
    setRemovingUserId = _React$useState28[1];
  var _useQuery6 = useQuery(ORGANISATION_TEAMS_QUERY, {
      variables: {
        organisationId: organisationId
      }
    }),
    teamsData = _useQuery6.data,
    teamsLoading = _useQuery6.loading,
    refetchTeams = _useQuery6.refetch;
  var _useMutation = useMutation(ADD_LEAVE_STATUS_CHANGE_USER_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    addLeaveStatusChangeUser = _useMutation2[0],
    addLeaveStatusChangeUserLoading = _useMutation2[1].loading;
  var _useMutation3 = useMutation(REMOVE_LEAVE_APPROVER_MUTATION),
    _useMutation4 = _slicedToArray(_useMutation3, 2),
    removeLeaveApproverMutation = _useMutation4[0],
    removeLeaveApproverLoading = _useMutation4[1].loading;
  var currentApprovers = (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove === void 0 ? void 0 : _leaveSettingsApprove.approvedList) || [];
  var approverUserIds = new Set(currentApprovers.map(function (a) {
    return a.userId;
  }));
  var personOptions = ((userListData === null || userListData === void 0 ? void 0 : userListData.getLeaveUserListing) || []).filter(function (item) {
    return !approverUserIds.has(item.userId);
  }).map(function (item) {
    return {
      label: item.displayName,
      value: item.userId
    };
  });
  var teamOptions = [{
    label: "All Teams (Global)",
    value: "all"
  }].concat(_toConsumableArray((teamsData === null || teamsData === void 0 ? void 0 : (_teamsData$organisati = teamsData.organisationTeams) === null || _teamsData$organisati === void 0 ? void 0 : _teamsData$organisati.map(function (t) {
    return {
      label: t.teamName,
      value: t.teamId
    };
  })) || []));
  var refetchQueries = [{
    query: LEAVE_SETTINGS_APPROVED_LIST_QUERY,
    variables: {
      organisationId: organisationId
    }
  }];
  var handleAdd = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var teamIds, _response$data, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (selectedPerson) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            if (!currentApprovers.some(function (a) {
              return a.userId === selectedPerson.value;
            })) {
              _context.next = 5;
              break;
            }
            toast.error("This person is already an approver");
            return _context.abrupt("return");
          case 5:
            teamIds = selectedTeam.map(function (t) {
              return t.value;
            });
            _context.prev = 6;
            _context.next = 9;
            return addLeaveStatusChangeUser({
              variables: {
                organisationId: organisationId,
                userId: selectedPerson.value,
                teamIds: teamIds
              },
              awaitRefetchQueries: true,
              refetchQueries: refetchQueries
            });
          case 9:
            response = _context.sent;
            if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.addLeaveStatusChangeUser)) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              setSelectedPerson(null);
              setSelectedTeam([{
                label: "All Teams (Global)",
                value: "all"
              }]);
              toast.success("Approver added successfully!");
            }
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](6);
            toast.error("Error Occurred, Try again later!!!");
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[6, 13]]);
    }));
    return function handleAdd() {
      return _ref4.apply(this, arguments);
    };
  }();
  var handleRemove = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(userId) {
      var _response$data2, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setRemovingUserId(userId);
            _context2.prev = 1;
            _context2.next = 4;
            return removeLeaveApproverMutation({
              variables: {
                organisationId: organisationId,
                userId: userId
              },
              awaitRefetchQueries: true,
              refetchQueries: refetchQueries
            });
          case 4:
            response = _context2.sent;
            if (!(response !== null && response !== void 0 && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.removeLeaveApprover)) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              toast.success("Approver removed successfully!");
            }
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            toast.error("Error Occurred, Try again later!!!");
          case 11:
            _context2.prev = 11;
            setRemovingUserId(null);
            return _context2.finish(11);
          case 14:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 8, 11, 14]]);
    }));
    return function handleRemove(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-approver-header"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "leave-settings-row-leave-type-label leave-setting-row-color"
  }, "Leave Approvers")), /*#__PURE__*/React.createElement("p", {
    className: "leave-setting-filter-year-type-text"
  }, "Manage who can approve or reject leave requests. Select \"All Teams (Global)\" to let them approve leaves across the entire organization, or choose a specific team."), /*#__PURE__*/React.createElement("div", {
    className: "leave-approver-current-section"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leave-setting-filter-year-type-text1"
  }, "Current Approvers"), /*#__PURE__*/React.createElement("div", {
    className: "leave-approver-chips"
  }, leaveSettingsApprovedLoading ? /*#__PURE__*/React.createElement("span", {
    className: "leave-approver-empty"
  }, "Loading...") : currentApprovers.length === 0 ? /*#__PURE__*/React.createElement("span", {
    className: "leave-approver-empty"
  }, "No approvers assigned") : currentApprovers.map(function (approver) {
    var _approver$teamNames;
    return /*#__PURE__*/React.createElement("div", {
      key: approver.userId,
      className: "leave-approver-chip"
    }, /*#__PURE__*/React.createElement(FiUsers, {
      className: "leave-approver-chip-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "leave-approver-chip-name"
    }, approver.displayName), /*#__PURE__*/React.createElement("span", {
      className: "leave-approver-chip-team"
    }, "(", ((_approver$teamNames = approver.teamNames) === null || _approver$teamNames === void 0 ? void 0 : _approver$teamNames.length) > 0 ? approver.teamNames.join(", ") : approver.isAdmin ? "Admin" : "All Teams", ")"), !approver.isAdmin ? /*#__PURE__*/React.createElement("button", {
      className: "leave-approver-chip-remove",
      onClick: function onClick() {
        return handleRemove(approver.userId);
      },
      disabled: addLeaveStatusChangeUserLoading || removingUserId === approver.userId
    }, removingUserId === approver.userId ? /*#__PURE__*/React.createElement(VscLoading, {
      className: "review-loading-svg"
    }) : "×") : null);
  }))), /*#__PURE__*/React.createElement("hr", {
    className: "leave-approver-divider"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-approver-add-section"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leave-approver-section-label"
  }, "Add New Approver"), /*#__PURE__*/React.createElement("div", {
    className: "leave-approver-add-row"
  }, /*#__PURE__*/React.createElement(Select, {
    value: selectedPerson,
    onChange: function onChange(e) {
      setSelectedPerson(e);
      setSelectedTeam([{
        label: "All Teams (Global)",
        value: "all"
      }]);
      refetchTeams({
        organisationId: organisationId,
        userId: e === null || e === void 0 ? void 0 : e.value
      });
    },
    options: personOptions,
    placeholder: "Select a person",
    isLoading: userListLoading,
    className: "leave-approver-person-select",
    classNamePrefix: "leave-approver-select"
  }), /*#__PURE__*/React.createElement(Select, {
    value: selectedTeam,
    onChange: function onChange(selected) {
      if (!selected || selected.length === 0) {
        setSelectedTeam([]);
        return;
      }
      var lastSelected = selected[selected.length - 1];
      if (lastSelected.value === "all") {
        setSelectedTeam([{
          label: "All Teams (Global)",
          value: "all"
        }]);
      } else {
        setSelectedTeam(selected.filter(function (t) {
          return t.value !== "all";
        }));
      }
    },
    options: teamOptions,
    isLoading: teamsLoading,
    isDisabled: !selectedPerson,
    isMulti: true,
    className: "leave-approver-team-select",
    classNamePrefix: "leave-approver-select"
  }), /*#__PURE__*/React.createElement(Button, {
    className: "leave-approver-add-btn",
    onClick: handleAdd,
    disabled: !selectedPerson || addLeaveStatusChangeUserLoading
  }, addLeaveStatusChangeUserLoading ? "Adding..." : "+ Add")), /*#__PURE__*/React.createElement("p", {
    className: "leave-approver-info-note"
  }, /*#__PURE__*/React.createElement("span", {
    className: "leave-approver-info-icon"
  }, "\u24D8"), " By default, \"All Teams (Global)\" is selected \u2014 the approver can manage leave requests from everyone.")));
};
var LeaveYearSettings = function LeaveYearSettings(props) {
  var organisationId = props.organisationId,
    leaveSettingsApprovedLoading = props.leaveSettingsApprovedLoading,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    leaveSettingsApprovedError = props.leaveSettingsApprovedError;
  var _React$useState29 = React.useState(null),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    yearParameterCheck = _React$useState30[0],
    setYearParameterCheck = _React$useState30[1];
  var _React$useState31 = React.useState(false),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    showAnnualCycleConfirm = _React$useState32[0],
    setShowAnnualCycleConfirm = _React$useState32[1];
  var _React$useState33 = React.useState(false),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    showSubmitButton = _React$useState34[0],
    setShowSubmitButton = _React$useState34[1];
  // const [editButton, setEditButton] = React.useState(true);

  var yearList = [{
    label: "Calendar Year (1st of January to 31st of December)",
    value: "calender-year"
  }, {
    label: "Financial Year (1st of April to 31st of March)",
    value: "financial-year"
  }];
  React.useEffect(function () {
    var _leaveSettingsApprove2, _leaveSettingsApprove4;
    if ((leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove2 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove2 === void 0 ? void 0 : _leaveSettingsApprove2.leaveYearSettings) !== null && yearParameterCheck == null) {
      var leaveCheck = yearList.find(function (u) {
        var _leaveSettingsApprove3;
        return u.value === (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove3 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove3 === void 0 ? void 0 : _leaveSettingsApprove3.leaveYearSettings);
      });
      setYearParameterCheck(leaveCheck);
    } else if ((leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove4 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove4 === void 0 ? void 0 : _leaveSettingsApprove4.leaveYearSettings) == null && yearParameterCheck == null) {
      setYearParameterCheck({
        label: "Calendar Year (1st of January to 31st of December)",
        value: "calender-year"
      });
    }
  }, [leaveSettingsApprovedData]);
  var _useMutation5 = useMutation(UPDATE_LEAVE_SETTINGS_MUTATION),
    _useMutation6 = _slicedToArray(_useMutation5, 2),
    updateLeaveSettings = _useMutation6[0],
    updateLeaveSettingsLoading = _useMutation6[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(actions) {
      var variables, statusChangeResponse;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            variables = {
              organisationId: organisationId,
              yearType: yearParameterCheck.value
            };
            _context3.prev = 1;
            _context3.next = 4;
            return updateLeaveSettings({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_APPROVED_LIST_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 4:
            statusChangeResponse = _context3.sent;
            if (!statusChangeResponse || !statusChangeResponse.data || statusChangeResponse.data.updateLeaveSettings == false) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              setShowSubmitButton(false);
              toast.success("Settings updated successfully!");
            }
            _context3.next = 11;
            break;
          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](1);
            toast.error("Error Occurred, Try again later!!!");
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 8]]);
    }));
    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }(), [yearParameterCheck]);
  var handleLeaveSettingsChange = function handleLeaveSettingsChange(e) {
    setYearParameterCheck(e);
    // setErrButton(false);
    // setShowSubmitButton(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-leave-type-label"
  }, /*#__PURE__*/React.createElement("h6", null, "Annual Cycle Year Configuration"), " "), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-worked-year-list-form-group"
  }, /*#__PURE__*/React.createElement("p", {
    className: "leave-setting-filter-year-type-text"
  }, "Choose the required annual cycle. Based on your selection, the leave balance will get reset."), /*#__PURE__*/React.createElement(Select, {
    value: yearParameterCheck,
    onChange: function onChange(e) {
      handleLeaveSettingsChange(e);
      setShowSubmitButton(true);
    },
    options: yearList,
    className: "leave-settings-filter-status-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User",
    isLoading: leaveSettingsApprovedLoading
  }), /*#__PURE__*/React.createElement("p", {
    className: "leave-settings-modal-note-text"
  }, "Changing the annual cycle will reset employees\u2019 current leave balances and recalculate them based on the newly selected cycle. Previously available leave balances will not be carried forward."), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-modal-save-button-div"
  }, " ", showSubmitButton ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "leave-settings-modal-update-settings",
    type: "submit",
    onClick: function onClick() {
      return setShowAnnualCycleConfirm(true);
    }
  }, updateLeaveSettingsLoading ? "Loading..." : "Save Changes")) : null)), /*#__PURE__*/React.createElement(Modal, {
    show: showAnnualCycleConfirm,
    onHide: function onHide() {
      return setShowAnnualCycleConfirm(false);
    },
    className: "leave-settings-annual-cycle-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Changing the annual cycle will reset leave balances")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "Changing the annual cycle will reset employees\u2019 current leave balances and recalculate them based on the newly selected cycle. Previously available leave balances will not be carried forward."), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "leave-settings-annual-cycle-highlight"
  }, "Example:"), " If an employee has a default leave balance of ", /*#__PURE__*/React.createElement("span", {
    className: "leave-settings-annual-cycle-highlight"
  }, "12 days"), ", has already applied for", " ", /*#__PURE__*/React.createElement("span", {
    className: "leave-settings-annual-cycle-highlight"
  }, "5 days"), ", and currently has", " ", /*#__PURE__*/React.createElement("span", {
    className: "leave-settings-annual-cycle-highlight"
  }, "7 days remaining"), ", their leave balance will be reset to the default ", /*#__PURE__*/React.createElement("span", {
    className: "leave-settings-annual-cycle-highlight"
  }, "12 days"), " after the annual cycle is changed."), /*#__PURE__*/React.createElement("h6", {
    className: "leave-settings-annual-cycle-highlight mb-0"
  }, "Are you sure you want to continue?")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return setShowAnnualCycleConfirm(false);
    },
    disabled: updateLeaveSettingsLoading
  }, "No"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-details-task-card-delete-button",
    onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return handleSubmit();
          case 2:
            setShowAnnualCycleConfirm(false);
          case 3:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })),
    disabled: updateLeaveSettingsLoading
  }, updateLeaveSettingsLoading ? "Loading..." : "Yes, Change Annual Cycle"))));
};
var LeavePermissionSettings = function LeavePermissionSettings(props) {
  var _leaveSettingsApprove6, _leaveSettingsApprove7;
  var organisationId = props.organisationId,
    leaveSettingsApprovedLoading = props.leaveSettingsApprovedLoading,
    leaveSettingsApprovedData = props.leaveSettingsApprovedData,
    leaveSettingsApprovedError = props.leaveSettingsApprovedError;
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    showSubmitButton = _React$useState36[0],
    setShowSubmitButton = _React$useState36[1];
  var _useMutation7 = useMutation(UPDATE_LEAVE_PERMISSION_SETTINGS_MUTATION),
    _useMutation8 = _slicedToArray(_useMutation7, 2),
    updateLeavePermissionSettings = _useMutation8[0],
    updateLeaveSettingsLoading = _useMutation8[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(values) {
      var _leaveSettingsApprove5;
      var variables, statusChangeResponse;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            variables = {
              organisationId: organisationId,
              leaveApplyForPastDay: (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove5 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove5 === void 0 ? void 0 : _leaveSettingsApprove5.leavePermissions) === values.leaveApplyPastDay ? null : values.leaveApplyPastDay.toString()
            };
            _context5.prev = 1;
            _context5.next = 4;
            return updateLeavePermissionSettings({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_APPROVED_LIST_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 4:
            statusChangeResponse = _context5.sent;
            if (!statusChangeResponse || !statusChangeResponse.data || statusChangeResponse.data.updateLeavePermissionSettings == false) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              toast.success("Settings updated successfully!");
            }
            _context5.next = 11;
            break;
          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](1);
            toast.error("Error Occurred, Try again later!!!");
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 8]]);
    }));
    return function (_x3) {
      return _ref8.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-row-leave-type-label"
  }, /*#__PURE__*/React.createElement("h6", null, "Permissions"), " "), /*#__PURE__*/React.createElement("div", {
    className: "leave-settings-worked-year-list-form-group"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      leaveApplyPastDay: leaveSettingsApprovedData !== null && leaveSettingsApprovedData !== void 0 && (_leaveSettingsApprove6 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) !== null && _leaveSettingsApprove6 !== void 0 && _leaveSettingsApprove6.leavePermissions ? (leaveSettingsApprovedData === null || leaveSettingsApprovedData === void 0 ? void 0 : (_leaveSettingsApprove7 = leaveSettingsApprovedData.leaveSettingsApprovedUserList) === null || _leaveSettingsApprove7 === void 0 ? void 0 : _leaveSettingsApprove7.leavePermissions) == "true" ? true : false : true
    }
    // validationSchema={MembersSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref9) {
    var isSubmitting = _ref9.isSubmitting,
      values = _ref9.values,
      setFieldValue = _ref9.setFieldValue;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("div", {
      className: ""
    }, /*#__PURE__*/React.createElement(Form.Group, {
      onChange: function onChange(e) {
        setShowSubmitButton(true);
      }
    }, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "leaveApplyPastDay",
      checked: values.leaveApplyPastDay,
      label: "Enable apply leave for past days",
      id: "Enable-leave-apply-days",
      className: "track-settingts-checkbox"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-modal-save-button-div"
    }, showSubmitButton ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "leave-settings-modal-update-settings",
      type: "submit",
      disabled: updateLeaveSettingsLoading || isSubmitting
    }, updateLeaveSettingsLoading || isSubmitting ? "Loading..." : "Save Changes")) : null));
  })));
};
var resetData = [{
  label: "Monthly",
  value: "Monthly"
},
// {
//   label: "Quarterly",
//   value: "Quarterly",
// },
// {
//   label: "Half-yearly",
//   value: "Half-yearly",
// },
{
  label: "Annually",
  value: "Annually"
}];
var categoriesData = [{
  label: "Paid",
  value: "Paid"
}, {
  label: "Unpaid",
  value: "Unpaid"
}];
var LeaveTypeModal = function LeaveTypeModal(props) {
  var _userWithSearch, _userWithSearch2;
  var leaveTypeModalShow = props.leaveTypeModalShow,
    handleLeaveTypeClose = props.handleLeaveTypeClose,
    userId = props.userId,
    organisationId = props.organisationId,
    role = props.role,
    teamId = props.teamId;
  if (leaveTypeModalShow == null) {
    return null;
  }
  var innerRef = useRef();
  useEffect(function () {
    innerRef.current && innerRef.current.focus();
    setLeaveTypeLimitError("");
  }, [leaveTypeModalShow]);
  var _React$useState37 = React.useState(true),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    isPriorityCheck = _React$useState38[0],
    setIsPriorityCheck = _React$useState38[1];
  var _React$useState39 = React.useState([]),
    _React$useState40 = _slicedToArray(_React$useState39, 2),
    userActive = _React$useState40[0],
    setUserActive = _React$useState40[1];
  var _React$useState41 = React.useState(""),
    _React$useState42 = _slicedToArray(_React$useState41, 2),
    searchUser = _React$useState42[0],
    setSearchUser = _React$useState42[1];
  var _React$useState43 = React.useState(true),
    _React$useState44 = _slicedToArray(_React$useState43, 2),
    isUserSelected = _React$useState44[0],
    setUserSelected = _React$useState44[1];
  var _React$useState45 = React.useState("false"),
    _React$useState46 = _slicedToArray(_React$useState45, 2),
    isUserNavCheck = _React$useState46[0],
    setIsUserNavCheck = _React$useState46[1];
  var _React$useState47 = React.useState(null),
    _React$useState48 = _slicedToArray(_React$useState47, 2),
    leaveId = _React$useState48[0],
    setLeaveId = _React$useState48[1];
  var _React$useState49 = React.useState(""),
    _React$useState50 = _slicedToArray(_React$useState49, 2),
    leaveTypeLimitError = _React$useState50[0],
    setLeaveTypeLimitError = _React$useState50[1];
  var _useQuery7 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    usersLoading = _useQuery7.loading,
    usersData = _useQuery7.data,
    usersError = _useQuery7.error,
    userListRefetch = _useQuery7.refetch;
  React.useEffect(function () {
    if (usersData !== null && usersData !== void 0 && usersData.getUserListing) {
      var _usersData$getUserLis;
      var selectedUserIds = usersData === null || usersData === void 0 ? void 0 : (_usersData$getUserLis = usersData.getUserListing) === null || _usersData$getUserLis === void 0 ? void 0 : _usersData$getUserLis.map(function (team) {
        return team.userId;
      });
      setUserActive(selectedUserIds);
    }
  }, [usersData]);
  var _useMutation9 = useMutation(ADD_LEAVE_TYPE_MUTATION),
    _useMutation10 = _slicedToArray(_useMutation9, 2),
    addLeaveTypes = _useMutation10[0],
    addLeaveTypeLoading = _useMutation10[1].loading;
  var _useMutation11 = useMutation(ADD_USER_LEAVE_TYPE_MUTATION),
    _useMutation12 = _slicedToArray(_useMutation11, 2),
    addUserLeaveTypesList = _useMutation12[0],
    addUserLeaveTypeLoading = _useMutation12[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(values, actions) {
      var leaveTypes, leaveTypeDaysCount, reset, carryForward, category, holidayAddResponse, serverMessage;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            leaveTypes = values.leaveTypes, leaveTypeDaysCount = values.leaveTypeDaysCount, reset = values.reset, carryForward = values.carryForward, category = values.category;
            setLeaveTypeLimitError("");
            _context6.prev = 2;
            _context6.next = 5;
            return addLeaveTypes({
              variables: {
                organisationId: organisationId,
                leaveType: leaveTypes,
                userId: userId,
                leaveTypeDaysCount: leaveTypeDaysCount,
                resetLeaveBalance: reset == "" ? "Annually" : reset,
                carryForward: carryForward == true ? "true" : "false",
                leaveTypeVisibility: isPriorityCheck ? "public" : "private",
                category: category == "" ? "Paid" : category
              },
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LEAVE_TYPE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 5:
            holidayAddResponse = _context6.sent;
            if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.addLeaveTypes == "false") {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              // Resets form after submission is complete
              actions.resetForm();
              actions.setSubmitting(false);
              setLeaveId(holidayAddResponse.data.addLeaveTypes);
              if (!isPriorityCheck) {
                setIsUserNavCheck(true);
              }
              if (isPriorityCheck) {
                toast.success("Leave type added successfully!");
                handleLeaveTypeClose();
              }
            }
            _context6.next = 14;
            break;
          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](2);
            // Some server messages use a curly apostrophe and some a straight one, so
            // "You've" and "You’ve" are different strings. Normalised before matching,
            // otherwise a branch silently misses on the wrong quote character.
            serverMessage = (_context6.t0.message || "").replace(/\u2019/g, "'");
            if (serverMessage.includes("Leave type already exist")) {
              actions.setFieldError("leaveTypes", "Already Exists");
            } else if (serverMessage.includes("You've reached the Free plan limit of 10 leave types") || serverMessage.includes("You've reached the maximum of 100 leave types")) {
              // Plan ceiling reached (checkLeaveTypeTotalCount). Not a problem with the
              // name field, so it goes to formError, which renders under the Create
              // Leave Type button. The server message already names the plan and its
              // limit, so show it as-is.
              actions.setFieldError("formError", _context6.t0.message);
            } else if (serverMessage.includes("requests per minute")) {
              // Per-minute guard (checkLeaveTypePerMinCount). Matched on the phrase
              // rather than the count so it keeps working if the threshold changes.
              actions.setFieldError("formError", "You’ve reached the limit of 5 requests per minute. Please try again in a minute.");
            } else {
              toast.error("Error Occurred, Try again later!!!");
            }

            // Runs for every branch: leaving it inside one of them keeps the form
            // stuck in its submitting state for the others.
            actions.setSubmitting(false);
          case 14:
          case "end":
            return _context6.stop();
        }
      }, _callee6, null, [[2, 9]]);
    }));
    return function (_x4, _x5) {
      return _ref10.apply(this, arguments);
    };
  }(), [isPriorityCheck, leaveId, isUserNavCheck, userActive]);
  var handleUserSubmitButton = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var holidayAddResponse;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return addUserLeaveTypesList({
            variables: {
              organisationId: organisationId,
              leaveId: leaveId,
              //userId,
              userId: userActive
              //leaveTypeVisibility : isPriorityCheck ? "public":"private" ,
            },
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: LEAVE_SETTINGS_LIST_QUERY,
              variables: {
                organisationId: organisationId,
                limit: LIMIT,
                offset: 0
              }
            }, {
              query: LEAVE_TYPE_LIST_COUNT_QUERY,
              variables: {
                organisationId: organisationId
              }
            }]
          });
        case 3:
          holidayAddResponse = _context7.sent;
          if (!holidayAddResponse || !holidayAddResponse.data || holidayAddResponse.data.addUserLeaveTypesList == false) {
            toast.error("Error Occurred, Try again later!!!");
          } else {
            toast.success("Leave type added successfully!");
            handleLeaveTypeClose();
          }
          _context7.next = 10;
          break;
        case 7:
          _context7.prev = 7;
          _context7.t0 = _context7["catch"](0);
          toast.error("Error Occurred, Try again later!!!");
        case 10:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 7]]);
  })), [isPriorityCheck, leaveId, isUserNavCheck, userActive]);
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getUserListing : null;
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var handleKey = function handleKey(data) {
    // if (data == "private") {
    setIsPriorityCheck(function (prev) {
      return prev === true ? false : true;
    });
    //}
  };
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp, _filterUsersData$disp2, _filterUsersData$disp3, _filterUsersData$disp4;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp = filterUsersData.displayName) === null || _filterUsersData$disp === void 0 ? void 0 : (_filterUsersData$disp2 = _filterUsersData$disp.toLowerCase) === null || _filterUsersData$disp2 === void 0 ? void 0 : (_filterUsersData$disp3 = _filterUsersData$disp2.call(_filterUsersData$disp)) === null || _filterUsersData$disp3 === void 0 ? void 0 : (_filterUsersData$disp4 = _filterUsersData$disp3.includes) === null || _filterUsersData$disp4 === void 0 ? void 0 : _filterUsersData$disp4.call(_filterUsersData$disp3, searchUser.toLowerCase());
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleLeaveTypeClose,
    centered: true,
    className: "project-task-modals-root "
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, isUserNavCheck == "false" ? "Add Leave Type" : "Assign Leave Type To")), /*#__PURE__*/React.createElement(Modal.Body, null, isUserNavCheck == "false" ? /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      leaveTypes: "",
      reset: "Annually",
      carryForward: null,
      category: "Paid"
    },
    validationSchema: LeaveTypesSchema,
    onSubmit: handleSubmit
  }, function (_ref12) {
    var setFieldValue = _ref12.setFieldValue,
      values = _ref12.values,
      errors = _ref12.errors;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "leaveTypes"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "project-task-modals-edit-task-label-name"
      }, "Name of the Leave Type ", /*#__PURE__*/React.createElement("sup", {
        className: "project-task-modals-edit-task-label-name-star"
      }, "*")), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error leave-type-err "
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "name",
        type: "text",
        placeholder: "Ex: Casual Leave",
        className: "leave-settings-edit-task-label-input"
      }, field, {
        // autofocus
        // autoFocus={true}
        ref: innerRef
      })));
    }), /*#__PURE__*/React.createElement(ControlLabel, {
      className: "leave-settings-edit-task-label-name-label"
    }, "Leave Balance Settings"), /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-type-wrapper-div"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "leaveTypeDaysCount"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "leave-settings-edit-task-label-name"
      }, "Total Balance"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "leave-setting-time-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "count",
        type: "number",
        min: "0",
        step: "0.5",
        placeholder: "Ex: 5",
        className: "leave-settings-edit-task-label-input"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "leave-setting-time-option-div-hours-text"
      }, "Days")), /*#__PURE__*/React.createElement(ControlLabel, {
        className: "leave-setting-span-help-text"
      }, "If you didn't enter any value, unlimited leaves will be applied"));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "reset"
    }, function (_ref13) {
      var field = _ref13.field,
        form = _ref13.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Reset Leave Balance"), /*#__PURE__*/React.createElement(FormControl, {
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input",
        onChange: function onChange(e) {
          setFieldValue("reset", e.target.value);
          setFieldValue("carryForward", e.target.value == "Monthly" ? true : false);
        },
        value: values.reset
        // {...field}
      }, /*#__PURE__*/React.createElement("option", {
        key: "select-leave-type",
        value: " ",
        disabled: "true"
      }, "Select Leave Reset time"), resetData === null || resetData === void 0 ? void 0 : resetData.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.label
        }, key.label);
      })));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "carryForward",
      checked: values.carryForward == null && values.reset == "Monthly" ? true : values.carryForward,
      label: "Enable leave carry forward",
      id: "cary-forward",
      className: "leave-type-settingts-checkbox"
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "category"
    }, function (_ref14) {
      var field = _ref14.field,
        form = _ref14.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Choose Leave Category"), /*#__PURE__*/React.createElement(FormControl, {
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input",
        onChange: function onChange(e) {
          setFieldValue("category", e.target.value);
        },
        value: values.category
        // {...field}
      }, /*#__PURE__*/React.createElement("option", {
        key: "select-leave-type",
        value: " ",
        disabled: "true"
      }, "Select Leave Category"), categoriesData === null || categoriesData === void 0 ? void 0 : categoriesData.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.label
        }, key.label);
      })));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-accordion"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-project-tasks-modal-content-header-setting"
    }, /*#__PURE__*/React.createElement(HiLockClosed, {
      className: "project-tasks-modal-content-header-setting-icon"
    }), " Assign this leave type to all members"), /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-task-modal-private-toggle-div-command-line"
    }, "You can assign the selective members to this leave type by unselecting this option")), /*#__PURE__*/React.createElement("div", {
      className: "tasks-rule-uparrow toggle-switch",
      onClick: function onClick() {
        return handleKey("private");
      }
    }, /*#__PURE__*/React.createElement("label", {
      "for": "chkTest"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("toggle-track", {
        "toggle-track-nav-right-div": isPriorityCheck
      })
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, leaveTypeLimitError ? /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-modal-limit-error text-center"
    }, leaveTypeLimitError) : null, /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-modal-button text-center"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "leave-settings-modal-save-button",
      type: "submit",
      disabled: addLeaveTypeLoading
    }, addLeaveTypeLoading ? "Loading..." : "Create Leave Type"), errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "leave-settings-form-error"
    }, errors.formError) : null))))));
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "project-task-acc-collapse-whole-div-data"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-content-person-name-header-section-content w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-searchbox-wrapper"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search employee name"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-modals-user-label-section-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-setting-project-task-modals-user-label-section"
  }, "Employee Names"), (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive([]);
      setUserSelected(true);
    }
  }, "Unselect All Employees") : /*#__PURE__*/React.createElement("p", {
    //variant="outline-secondary"
    className: "tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive(userIds);
      setUserSelected(true);
    }
  }, "Select All Employees")), /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-listing"
  }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch = userWithSearch(userDetails)) !== null && _userWithSearch !== void 0 && _userWithSearch.length ? (_userWithSearch2 = userWithSearch(userDetails)) === null || _userWithSearch2 === void 0 ? void 0 : _userWithSearch2.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement("div", {
      className: "project-task-modals-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person",
      onClick: function onClick() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-my-projects-modal-content-header-team-name"
    }, user.displayName)), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-team-name"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    })));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\" ")))))), /*#__PURE__*/React.createElement("div", {
    className: "project-task-list-modal-save-button"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "leave-setting-project-task-modals-save-button",
    onClick: function onClick() {
      handleUserSubmitButton();
    },
    disabled: addUserLeaveTypeLoading
  }, addUserLeaveTypeLoading ? "Loading..." : "Done")))));
};

// const LeaveTypeModalEdit = (props) => {
//   const {
//     leaveTypeModalEditShow,
//     handleLeaveTypeEditClose,
//     userId,
//     organisationId,
//     leaveTypeEditList,
//     setLeaveTypeEditList,
//   } = props;

//   if (leaveTypeModalEditShow == null) {
//     return null;
//   }

//   const innerRef = useRef();
//   useEffect(() => innerRef.current && innerRef.current.focus());

//   const { leaveTypeName, leaveTypeId, leaveTypeCount, resetLeaveBalance, leaveCarryForward, leaveUser, leaveTypeVisibility, leaveNature } = leaveTypeModalEditShow;

//   const { teamId, role } = React.useContext(FilterContext);

//   const [searchUser, setSearchUser] = React.useState("");
//   const [isUserSelected, setUserSelected] = React.useState(true);
//   const [isPriorityCheck, setIsPriorityCheck] = React.useState(leaveTypeVisibility == "public" || leaveTypeVisibility == null ? false : true);

//   const {
//     loading: usersLoading,
//     data: usersData,
//     error: usersError,
//     refetch: userListRefetch,
//   } = useQuery(GET_USER_LISTING_QUERY, {
//     variables: {
//       organisationId,
//       teamId,
//       userRole: role,
//     },
//     skip: !organisationId,
//   });

//   const userDetails = !usersLoading && !usersError ? usersData?.getUserListing : null;
//   let selectedUserIds = [];

//   if (leaveUser?.length) {
//     selectedUserIds = leaveUser.map((team) => team.userId);
//   }

//   const userIds = userDetails?.map((user) => user.userId);

//   const [userActive, setUserActive] = React.useState(selectedUserIds);
//   const [publicActive, setPublicActive] = React.useState(userIds);

//   React.useEffect(() => {
//     const userId = usersData?.getUserListing?.map((user) => user.userId);
//     setPublicActive(userId);
//   }, [usersData]);

//   const [editLeaveTypes, { loading: editLeaveTypeLoading }] = useMutation(EDIT_LEAVE_TYPE_MUTATION);

//   const handleSubmit = React.useCallback(async (values, actions) => {
//     const { leaveTypes, leaveTypeDaysCount, reset, carryForward, category } = values;

//     const variables = {
//       organisationId,
//       leaveType: leaveTypes,
//       //userId,
//       leaveTypeId,
//       leaveTypeDaysCount,
//       resetLeaveBalance: reset == "" ? "Annually" : reset,
//       carryForward: carryForward == true ? "true" : "false",

//       leaveTypeVisibility: !isPriorityCheck ? "public" : "private",
//       userId: !isPriorityCheck ? publicActive : userActive,
//       category: category ? category : "Paid",
//     };

//     try {
//       const editLeaveTypesResponse = await editLeaveTypes({
//         variables,
//         refetchQueries: [
//           {
//             query: LEAVE_SETTINGS_LIST_QUERY,
//             variables: {
//               organisationId,
//               limit: LIMIT,
//               offset: 0,
//             },
//           },
//           {
//             query: LEAVE_TYPE_LIST_COUNT_QUERY,
//             variables: {
//               organisationId,
//             },
//           },
//         ],
//       });

//       // Resets form after submission is complete
//       actions.resetForm();
//       actions.setSubmitting(false);

//       if (
//         !editLeaveTypesResponse ||
//         !editLeaveTypesResponse.data ||
//         editLeaveTypesResponse.data.editLeaveTypes == false
//       ) {
//         toast.error("Error Occurred, Try again later!!!");
//       } else {
//         //      leaveTypeEditList,
//         // setLeaveTypeEditList,

//         let editLeave = [...leaveTypeEditList];
//         editLeave.push({ ...editLeaveTypesResponse.data.editLeaveTypes });
//         setLeaveTypeEditList([...editLeave]);

//         toast.success("Leave Type updated successfully!");
//         handleLeaveTypeEditClose();
//       }
//     } catch (error) {
//       toast.error("Error Occurred, Try again later!!!");
//       actions.setSubmitting(false);
//     }
//   }, [publicActive, userActive, isPriorityCheck]);

//   const handleKey = (data) => {
//     // if (data == "private") {
//     setIsPriorityCheck((prev) => (prev === true ? false : true));

//     const t = userDetails?.map((user) => user.userId);

//     setPublicActive(t);
//     //}
//   };
//   const userWithSearch = (userData) => {
//     if (!searchUser) {
//       return userData;
//     }

//     return userData.filter((filterUsersData) =>
//       filterUsersData?.displayName?.toLowerCase?.()?.includes?.(searchUser.toLowerCase())
//     );
//   };

//   return (
//     <Modal show onHide={handleLeaveTypeEditClose} centered className="project-task-modals-root" size={isPriorityCheck ? "lg" : "md"}>
//       <Modal.Header closeButton>
//         <Modal.Title className="project-task-modals-root-title">{"Edit Leave Types"}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Formik
//           initialValues={{
//             leaveTypes: leaveTypeName,
//             leaveTypeDaysCount: leaveTypeCount,
//             reset: resetLeaveBalance ? resetLeaveBalance : "Annually",
//             carryForward: leaveCarryForward == "true" ? true : false,
//             category: leaveNature ? leaveNature : "Paid",
//           }}
//           validationSchema={LeaveTypesSchema}
//           onSubmit={handleSubmit}
//         >
//           {({ setFieldValue, values }) => (
//             <FormikForm>
//               <Row>
//                 <Col xs={12} md={12} lg={12}>
//                   <div
//                     className={classNames("", {
//                       "leave-grid-for-edit-private": isPriorityCheck,
//                     })}
//                   >
//                     <div>
//                       <Field name="leaveTypes">
//                         {(fieldProps) => {
//                           const { field, meta } = fieldProps;
//                           return (
//                             <FormGroup>
//                               <ControlLabel className="project-task-modals-edit-task-label-name">Leave Types <sup className="project-task-modals-edit-task-label-name-star">*</sup> </ControlLabel>
//                               {meta.error && meta.touched ? (
//                                 <ControlLabel className="error">{meta.error}</ControlLabel>
//                               ) : null}
//                               <FormControl
//                                 name="name"
//                                 type="text"
//                                 placeholder="Ex: Casual Leave"
//                                 className="leave-settings-edit-task-label-input"
//                                 {...field}
//                                 ref={innerRef}
//                               />
//                             </FormGroup>
//                           );
//                         }}
//                       </Field>

//                       <ControlLabel className="leave-settings-edit-task-label-name-label">
//                         Leave Balance Settings
//                       </ControlLabel>

//                       <div className="leave-setting-type-wrapper-div">

//                         <Col xs={12} md={12} lg={12}>
//                           <Field name="leaveTypeDaysCount">
//                             {(fieldProps) => {
//                               const { field, meta } = fieldProps;
//                               return (
//                                 <FormGroup>
//                                   <ControlLabel className="leave-settings-edit-task-label-name">
//                                     Total Balance
//                                   </ControlLabel>
//                                   {meta.error && meta.touched ? (
//                                     <ControlLabel className="error">{meta.error}</ControlLabel>
//                                   ) : null}

//                                   <div className="leave-setting-time-option-div">
//                                     <FormControl
//                                       name="count"
//                                       type="number"
//                                       min="0"
//                                       step="0.5"
//                                       placeholder="Ex: 5"
//                                       className="leave-settings-edit-task-label-input"
//                                       {...field}
//                                     />
//                                     <span className="leave-setting-time-option-div-hours-text">Days</span>
//                                   </div>
//                                   <ControlLabel className="leave-setting-span-help-text">
//                                     If you didn't enter any value, unlimited leaves will be applied
//                                   </ControlLabel>
//                                 </FormGroup>
//                               );
//                             }}
//                           </Field>
//                         </Col>

//                         <Col xs={12} md={12} lg={12}>
//                           <Field name="reset">
//                             {({ field, form }) => {
//                               return (
//                                 <FormGroup className="my-projects-modal-content-name-field">
//                                   <ControlLabel className="apply-leave-modal-body-wrapper-form-div-field-label-name">
//                                     Reset Leave Balance
//                                   </ControlLabel>
//                                   <OverlayTrigger
//                                     rootClose
//                                     key={`active-working`}
//                                     placement={"bottom"}
//                                     overlay={
//                                       <Tooltip id={`tooltip-bottom`} className="count-tooltip-start">
//                                         <div>You can't edit Reset leave balance.</div>
//                                       </Tooltip>
//                                     }
//                                   >
//                                     {/* <FormControl
//                                       as="select"
//                                       className="apply-leave-modal-body-wrapper-form-div-field-input"
//                                       disabled={true}
//                                       {...field}
//                                     >
//                                       <option key={"select-leave-type"} value={" "}>
//                                         Select Leave Reset time
//                                       </option>
//                                       {resetData?.map((key, index) => {
//                                         return (
//                                           <option key={key.value} value={key.label}>
//                                             {key.label}
//                                           </option>
//                                         );
//                                       })}
//                                     </FormControl> */}
//                                     <div className="leave-type-edit-disable-button">
//                                       {resetLeaveBalance ? resetLeaveBalance : "Annually"}
//                                     </div>
//                                   </OverlayTrigger>
//                                 </FormGroup>
//                               );
//                             }}
//                           </Field>
//                         </Col>

//                         <Col xs={12} md={12} lg={12}>
//                           <Form.Group>
//                             <Field
//                               as={Form.Check}
//                               name="carryForward"
//                               checked={values.carryForward}
//                               label="Enable leave carry forward"
//                               id="cary-forward"
//                               className="leave-type-settingts-checkbox"
//                             />
//                           </Form.Group>
//                         </Col>

//                         <Col xs={12} md={12} lg={12}>
//                           <Field name="category">
//                             {({ field, form }) => {
//                               return (
//                                 <FormGroup className="my-projects-modal-content-name-field">
//                                   <ControlLabel className="apply-leave-modal-body-wrapper-form-div-field-label-name">
//                                     Choose Leave Category
//                                   </ControlLabel>

//                                   <FormControl
//                                     as="select"
//                                     className="apply-leave-modal-body-wrapper-form-div-field-input"
//                                     onChange={(e) => {
//                                       setFieldValue("category", e.target.value);
//                                     }}
//                                     value={values.category}
//                                   // {...field}
//                                   >
//                                     <option key={"select-leave-type"} value={" "} disabled={"true"}>
//                                       Select Leave Category
//                                     </option>
//                                     {categoriesData?.map((key, index) => {
//                                       return (
//                                         <option key={key.value} value={key.label}>
//                                           {key.label}
//                                         </option>
//                                       );
//                                     })}
//                                   </FormControl>
//                                 </FormGroup>
//                               );
//                             }}
//                           </Field>
//                         </Col>

//                       </div>
//                     </div>

//                     <Accordion
//                       className={classNames("task-modal-accordion-whole task-editmoldal-accordion", {
//                         " task-editmoldal-accordion--edit": isPriorityCheck,
//                       })}
//                       defaultActiveKey={!isPriorityCheck ? null : "0"}>
//                       <div onClick={() => handleKey("setting")}>
//                         <Accordion.Toggle
//                           as={Button}
//                           variant="link"
//                           eventKey="0"
//                           className="task-modal-content-header-team-name-acc"
//                         >
//                           <span className="project-detail-tasks-modal-content-header-setting">
//                             <HiLockClosed className="project-tasks-modal-content-header-setting-icon" /> Assign this
//                             leave type to all members
//                           </span>

//                           <div className="tasks-rule-uparrow toggle-switch">
//                             <label for="chkTest">
//                               <span
//                                 className={classNames("toggle-track", {
//                                   "toggle-track-nav-right-div": !isPriorityCheck,
//                                 })}
//                               ></span>
//                             </label>
//                           </div>
//                         </Accordion.Toggle>
//                       </div>
//                       <Accordion.Collapse eventKey="0">
//                         <div className="tasks-modal-content-person-name">
//                           <div className="tasks-modal-content-person-name-header">
//                             <div className="task-edit-modal-content-person-name-header-section">
//                               <div className="tasks-modal-content-person-name-header-section-label"></div>

//                               <div
//                                 className={classNames("my-projects-modal-content-person-name-header-section-content", {
//                                   "my-projects-modal-content-person-name-header-section-content--edit": isPriorityCheck,
//                                 })}>
//                                 <div className="my-projects-modal-searchbox-wrapper">
//                                   <SearchBar
//                                     value={searchUser}
//                                     onChange={setSearchUser}
//                                     placeholder="Search employee name"
//                                   />
//                                 </div>

//                                 {userActive?.length == userIds?.length ? (
//                                   <p
//                                     className="projects-tasks-modal-content-person-name-header-button"
//                                     onClick={() => {
//                                       setUserActive([]);
//                                       setUserSelected(false);
//                                     }}
//                                   >
//                                     Unselect All
//                                   </p>
//                                 ) : (
//                                   <p
//                                     //variant="outline-secondary"
//                                     className="projects-tasks-modal-content-person-name-header-button"
//                                     onClick={() => {
//                                       setUserActive(userIds);
//                                       setUserSelected(true);
//                                     }}
//                                   >
//                                     Select All
//                                   </p>
//                                 )}
//                               </div>
//                             </div>
//                           </div>

//                           <div className={classNames("project-details-tasks-modal-content-person-name-listing", {
//                             "project-details-tasks-modal-content-person-name-listing--edit": isPriorityCheck,
//                           })}
//                           >
//                             {usersLoading ? (
//                               <Loader />
//                             ) : userDetails && userWithSearch(userDetails)?.length ? (
//                               userWithSearch(userDetails)?.map((user, index) => {
//                                 let teamFirstName = user.displayName.match(/\b(\w)/g);
//                                 const teamNameIcon = teamFirstName.join("");

//                                 return (
//                                   <div className="my-projects-modal-content-person-name-listing-card-content" key={index}>
//                                     <div
//                                       className="tasks-modal-content-person-name-listing-card-content-person"
//                                       onClick={() => {
//                                         setUserSelected(true);
//                                         setUserActive((prev) => {
//                                           return prev.includes(user.userId)
//                                             ? prev.filter((a) => a !== user.userId)
//                                             : [...prev, user.userId];
//                                         });
//                                       }}
//                                     >
//                                       {user.profileUrl ? (
//                                         <>
//                                           <div className="task-card-avatar-profile">
//                                             <img
//                                               alt="Workfolio"
//                                               src={user?.profileUrl}
//                                               className="task-card-avatar-profile-img"
//                                             />
//                                           </div>
//                                         </>
//                                       ) : (
//                                         <div className="tasks-modal-content-person-name-listing-card-content-person-icon">
//                                           {user.displayName.charAt(0).toUpperCase()}
//                                         </div>
//                                       )}
//                                       <div className="my-projects-modal-content-header-team-name--edit">{user.displayName}</div>
//                                     </div>
//                                     <div className="my-projects-modal-content-team-name">
//                                       <input
//                                         type="checkbox"
//                                         id={user.userId}
//                                         name="myRadioGroup"
//                                         className="create-project-team-selection-control-checkbox"
//                                         checked={userActive.includes(user.userId)}
//                                         onChange={() => {
//                                           setUserSelected(true);
//                                           setUserActive((prev) => {
//                                             return prev.includes(user.userId)
//                                               ? prev.filter((a) => a !== user.userId)
//                                               : [...prev, user.userId];
//                                           });
//                                         }}
//                                       />
//                                     </div>
//                                   </div>
//                                 );
//                               })
//                             ) : (
//                               <div className="text-muted text-center">{`No member found for "${searchUser}"`}</div>
//                             )}
//                           </div>

//                         </div>
//                       </Accordion.Collapse>
//                     </Accordion>
//                   </div>
//                   <Row>
//                     <Col xs={12} md={12} lg={12}>
//                       <div className={classNames("leave-settings-modal-button text-center", {
//                         "leave-settings-modal-button-edit-private": isPriorityCheck,
//                       })}
//                       >
//                         <Button
//                           variant="primary"
//                           className="leave-settings-modal-save-button"
//                           type="submit"
//                           disabled={editLeaveTypeLoading}
//                         >
//                           {editLeaveTypeLoading ? "Loading..." : "Save Changes"}
//                         </Button>
//                       </div>
//                     </Col>
//                   </Row>
//                 </Col>
//               </Row>
//             </FormikForm>
//           )}
//         </Formik>
//       </Modal.Body>
//     </Modal>
//   );
// };

var LeaveTypeModalEdit = function LeaveTypeModalEdit(props) {
  var leaveTypeModalEditShow = props.leaveTypeModalEditShow,
    handleLeaveTypeEditClose = props.handleLeaveTypeEditClose,
    userId = props.userId,
    organisationId = props.organisationId,
    leaveTypeEditList = props.leaveTypeEditList,
    setLeaveTypeEditList = props.setLeaveTypeEditList;
  if (leaveTypeModalEditShow == null) {
    return null;
  }
  var innerRef = useRef();
  useEffect(function () {
    return innerRef.current && innerRef.current.focus();
  });
  var leaveTypeName = leaveTypeModalEditShow.leaveTypeName,
    leaveTypeId = leaveTypeModalEditShow.leaveTypeId,
    leaveTypeCount = leaveTypeModalEditShow.leaveTypeCount,
    resetLeaveBalance = leaveTypeModalEditShow.resetLeaveBalance,
    leaveCarryForward = leaveTypeModalEditShow.leaveCarryForward,
    leaveUser = leaveTypeModalEditShow.leaveUser,
    leaveTypeVisibility = leaveTypeModalEditShow.leaveTypeVisibility,
    leaveNature = leaveTypeModalEditShow.leaveNature;
  var _React$useContext3 = React.useContext(FilterContext),
    teamId = _React$useContext3.teamId,
    role = _React$useContext3.role;
  var _React$useState51 = React.useState("leave-details"),
    _React$useState52 = _slicedToArray(_React$useState51, 2),
    tabData = _React$useState52[0],
    setTabData = _React$useState52[1];
  var handleSubmit = null;
  var handleTabSelect = function handleTabSelect(key) {
    setTabData(key);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleLeaveTypeEditClose,
    centered: true,
    className: "leave-type-edit-modal-root",
    size: "lg"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-task-modals-root-title"
  }, "Edit ".concat(leaveTypeName, " Details"))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "leave-details",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    },
    className: "edit-user-wise-leave-history-tab-leave-root-tab"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "leave-details",
    title: /*#__PURE__*/React.createElement("span", null, "Leave Details")
  }, /*#__PURE__*/React.createElement(LeaveTypeBasicForm, {
    leaveTypeEditList: leaveTypeEditList,
    handleLeaveTypeEditClose: handleLeaveTypeEditClose
    //handleSubmit={handleSubmit}
    //editLeaveTypeLoading={editLeaveTypeLoading}
    ,
    leaveTypeModalEditShow: leaveTypeModalEditShow,
    organisationId: organisationId,
    setLeaveTypeEditList: setLeaveTypeEditList
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "leave-balance",
    title: /*#__PURE__*/React.createElement("span", null, "Leave Balance")
  }, /*#__PURE__*/React.createElement(BalanceSetting, {
    leaveTypeEditList: leaveTypeEditList,
    handleLeaveTypeEditClose: handleLeaveTypeEditClose
    //handleSubmit={handleSubmit}
    //editLeaveTypeLoading={editLeaveTypeLoading}
    ,
    leaveTypeModalEditShow: leaveTypeModalEditShow,
    organisationId: organisationId,
    setLeaveTypeEditList: setLeaveTypeEditList
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "member-assignment",
    title: /*#__PURE__*/React.createElement("span", null, "Member Assignment")
  }, /*#__PURE__*/React.createElement(MemberAssigment, {
    leaveTypeEditList: leaveTypeEditList,
    handleLeaveTypeEditClose: handleLeaveTypeEditClose
    //handleSubmit={handleSubmit}
    //editLeaveTypeLoading={editLeaveTypeLoading}
    ,
    leaveTypeModalEditShow: leaveTypeModalEditShow,
    organisationId: organisationId,
    teamId: teamId,
    role: role,
    setLeaveTypeEditList: setLeaveTypeEditList
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "carry-forward",
    title: /*#__PURE__*/React.createElement("span", null, "Carry Forward Rules")
  }, /*#__PURE__*/React.createElement(CarryForward, {
    leaveTypeEditList: leaveTypeEditList,
    handleLeaveTypeEditClose: handleLeaveTypeEditClose
    //handleSubmit={handleSubmit}
    //editLeaveTypeLoading={editLeaveTypeLoading}
    ,
    leaveTypeModalEditShow: leaveTypeModalEditShow,
    organisationId: organisationId,
    setLeaveTypeEditList: setLeaveTypeEditList
  })))));
};
var LeaveTypeBasicForm = function LeaveTypeBasicForm(props) {
  var leaveTypeEditList = props.leaveTypeEditList,
    handleLeaveTypeEditClose = props.handleLeaveTypeEditClose,
    leaveTypeModalEditShow = props.leaveTypeModalEditShow,
    organisationId = props.organisationId,
    setLeaveTypeEditList = props.setLeaveTypeEditList;
  var leaveTypeId = leaveTypeModalEditShow.leaveTypeId,
    leaveTypeName = leaveTypeModalEditShow.leaveTypeName,
    leaveNature = leaveTypeModalEditShow.leaveNature;
  var innerRef = useRef();
  var _useMutation13 = useMutation(EDIT_LEAVE_TYPE_MUTATION),
    _useMutation14 = _slicedToArray(_useMutation13, 2),
    editLeaveTypes = _useMutation14[0],
    editLeaveTypeLoading = _useMutation14[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(values, actions) {
      var leaveTypes, category, variables, _response$data3, response, updated;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            leaveTypes = values.leaveTypes, category = values.category;
            variables = {
              organisationId: organisationId,
              leaveType: leaveTypes,
              leaveTypeId: leaveTypeId,
              category: category ? category : "Paid"
            };
            _context8.prev = 2;
            _context8.next = 5;
            return editLeaveTypes({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LEAVE_TYPE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 5:
            response = _context8.sent;
            actions.setSubmitting(false);
            if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.editLeaveTypesForLeaveDetails) {
              _context8.next = 10;
              break;
            }
            toast.error("Error Occurred, Try again later!!!");
            return _context8.abrupt("return");
          case 10:
            // ✅ update local list (replace existing instead of push)
            updated = response.data.editLeaveTypesForLeaveDetails;
            setLeaveTypeEditList(function (prev) {
              return prev.map(function (item) {
                return item.leaveTypeId === updated.leaveTypeId ? updated : item;
              });
            });
            toast.success("Leave Type updated successfully!");
            actions.resetForm();
            handleLeaveTypeEditClose();
            _context8.next = 21;
            break;
          case 17:
            _context8.prev = 17;
            _context8.t0 = _context8["catch"](2);
            toast.error("Error Occurred, Try again later!!!");
            actions.setSubmitting(false);
          case 21:
          case "end":
            return _context8.stop();
        }
      }, _callee8, null, [[2, 17]]);
    }));
    return function (_x6, _x7) {
      return _ref15.apply(this, arguments);
    };
  }(), [organisationId, leaveTypeId]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      leaveTypes: leaveTypeName,
      category: leaveNature ? leaveNature : "Paid"
    },
    validationSchema: LeaveTypesSchema,
    onSubmit: handleSubmit
  }, function (_ref16) {
    var setFieldValue = _ref16.setFieldValue,
      values = _ref16.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("")
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "leaveTypes"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, null, "Leave Types ", /*#__PURE__*/React.createElement("sup", {
        className: "project-task-modals-edit-task-label-name-star"
      }, "*")), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "name",
        type: "text",
        placeholder: "Ex: Casual Leave",
        className: "leave-settings-edit-task-label-input"
      }, field, {
        ref: innerRef
      })));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "category"
    }, function (_ref17) {
      var field = _ref17.field,
        form = _ref17.form;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "my-projects-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "apply-leave-modal-body-wrapper-form-div-field-label-name"
      }, "Choose Leave Category"), /*#__PURE__*/React.createElement(FormControl, {
        as: "select",
        className: "apply-leave-modal-body-wrapper-form-div-field-input",
        onChange: function onChange(e) {
          setFieldValue("category", e.target.value);
        },
        value: values.category
        // {...field}
      }, /*#__PURE__*/React.createElement("option", {
        key: "select-leave-type",
        value: " ",
        disabled: "true"
      }, "Select Leave Category"), categoriesData === null || categoriesData === void 0 ? void 0 : categoriesData.map(function (key, index) {
        return /*#__PURE__*/React.createElement("option", {
          key: key.value,
          value: key.label
        }, key.label);
      })));
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-settings-edit-root-modal-button text-center")
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "leave-settings-modal-save-button",
      type: "submit",
      disabled: editLeaveTypeLoading
    }, editLeaveTypeLoading ? "Loading..." : "Save Changes")))))));
  }));
};
var BalanceSetting = function BalanceSetting(props) {
  var leaveTypeEditList = props.leaveTypeEditList,
    handleLeaveTypeEditClose = props.handleLeaveTypeEditClose,
    leaveTypeModalEditShow = props.leaveTypeModalEditShow,
    organisationId = props.organisationId,
    setLeaveTypeEditList = props.setLeaveTypeEditList;
  var leaveTypeCount = leaveTypeModalEditShow.leaveTypeCount,
    leaveTypeId = leaveTypeModalEditShow.leaveTypeId;
  var innerRef = useRef();
  var _useMutation15 = useMutation(EDIT_LEAVE_BALANCE_MUTATION),
    _useMutation16 = _slicedToArray(_useMutation15, 2),
    editLeaveBalance = _useMutation16[0],
    editLeaveTypeLoading = _useMutation16[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(values, actions) {
      var leaveTypeDaysCount, variables, _response$data4, response, updated;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            leaveTypeDaysCount = values.leaveTypeDaysCount; // IMPORTANT: empty → unlimited → send null
            if (leaveTypeDaysCount === "" || leaveTypeDaysCount === undefined) {
              leaveTypeDaysCount = null;
            }
            variables = {
              organisationId: organisationId,
              leaveTypeId: leaveTypeId,
              leaveTypeDaysCount: leaveTypeDaysCount
            };
            _context9.prev = 3;
            _context9.next = 6;
            return editLeaveBalance({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LEAVE_TYPE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 6:
            response = _context9.sent;
            actions.setSubmitting(false);
            if (response !== null && response !== void 0 && (_response$data4 = response.data) !== null && _response$data4 !== void 0 && _response$data4.editLeaveTypesForLeaveBalance) {
              _context9.next = 11;
              break;
            }
            toast.error("Error Occurred, Try again later!!!");
            return _context9.abrupt("return");
          case 11:
            updated = response.data.editLeaveTypesForLeaveBalance; // ✅ SAFE list update (no duplicates)
            setLeaveTypeEditList(function (prev) {
              return prev.map(function (item) {
                return item.leaveTypeId === updated.leaveTypeId ? _objectSpread(_objectSpread({}, item), updated) : item;
              });
            });
            toast.success("Leave balance updated successfully!");
            actions.resetForm();
            handleLeaveTypeEditClose();
            _context9.next = 22;
            break;
          case 18:
            _context9.prev = 18;
            _context9.t0 = _context9["catch"](3);
            toast.error("Error Occurred, Try again later!!!");
            actions.setSubmitting(false);
          case 22:
          case "end":
            return _context9.stop();
        }
      }, _callee9, null, [[3, 18]]);
    }));
    return function (_x8, _x9) {
      return _ref18.apply(this, arguments);
    };
  }(), [organisationId, leaveTypeId]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      leaveTypeDaysCount: leaveTypeCount
    }
    //validationSchema={LeaveTypesSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref19) {
    var setFieldValue = _ref19.setFieldValue,
      values = _ref19.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("")
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "leaveTypeDaysCount"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "leave-settings-edit-task-label-name"
      }, "Total Balance"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "leave-setting-time-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "count",
        type: "number",
        min: "0",
        step: "0.5",
        placeholder: "Ex: 5",
        className: "leave-settings-edit-task-label-input"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "leave-setting-time-option-div-hours-text"
      }, "Days")), /*#__PURE__*/React.createElement(ControlLabel, {
        className: "leave-setting-span-help-text"
      }, "If you didn't enter any value, unlimited leaves will be applied"));
    })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-settings-edit-root-modal-button text-center")
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "leave-settings-modal-save-button",
      type: "submit",
      disabled: editLeaveTypeLoading
    }, editLeaveTypeLoading ? "Loading..." : "Save Changes")))))));
  }));
};
var MemberAssigment = function MemberAssigment(props) {
  var _userWithSearch3, _userWithSearch4;
  var leaveTypeEditList = props.leaveTypeEditList,
    handleLeaveTypeEditClose = props.handleLeaveTypeEditClose,
    leaveTypeModalEditShow = props.leaveTypeModalEditShow,
    organisationId = props.organisationId,
    teamId = props.teamId,
    role = props.role,
    setLeaveTypeEditList = props.setLeaveTypeEditList;
  var leaveTypeVisibility = leaveTypeModalEditShow.leaveTypeVisibility,
    leaveUser = leaveTypeModalEditShow.leaveUser,
    leaveTypeId = leaveTypeModalEditShow.leaveTypeId;
  var _React$useState53 = React.useState(leaveTypeVisibility == "public" || leaveTypeVisibility == null ? false : true),
    _React$useState54 = _slicedToArray(_React$useState53, 2),
    isPriorityCheck = _React$useState54[0],
    setIsPriorityCheck = _React$useState54[1];
  var _React$useState55 = React.useState(""),
    _React$useState56 = _slicedToArray(_React$useState55, 2),
    searchUser = _React$useState56[0],
    setSearchUser = _React$useState56[1];
  var _React$useState57 = React.useState(true),
    _React$useState58 = _slicedToArray(_React$useState57, 2),
    isUserSelected = _React$useState58[0],
    setUserSelected = _React$useState58[1];
  var _useQuery8 = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    usersLoading = _useQuery8.loading,
    usersData = _useQuery8.data,
    usersError = _useQuery8.error,
    userListRefetch = _useQuery8.refetch;
  var userDetails = !usersLoading && !usersError ? usersData === null || usersData === void 0 ? void 0 : usersData.getUserListing : null;
  var selectedUserIds = [];
  if (leaveUser !== null && leaveUser !== void 0 && leaveUser.length) {
    selectedUserIds = leaveUser.map(function (team) {
      return team.userId;
    });
  }
  var userIds = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
    return user.userId;
  });
  var _React$useState59 = React.useState(selectedUserIds),
    _React$useState60 = _slicedToArray(_React$useState59, 2),
    userActive = _React$useState60[0],
    setUserActive = _React$useState60[1];
  var _React$useState61 = React.useState(userIds),
    _React$useState62 = _slicedToArray(_React$useState61, 2),
    publicActive = _React$useState62[0],
    setPublicActive = _React$useState62[1];
  React.useEffect(function () {
    var _usersData$getUserLis2;
    var userId = usersData === null || usersData === void 0 ? void 0 : (_usersData$getUserLis2 = usersData.getUserListing) === null || _usersData$getUserLis2 === void 0 ? void 0 : _usersData$getUserLis2.map(function (user) {
      return user.userId;
    });
    setPublicActive(userId);
  }, [usersData]);
  var _useMutation17 = useMutation(EDIT_LEAVE_MEMBER_MUTATION),
    _useMutation18 = _slicedToArray(_useMutation17, 2),
    editLeaveMembers = _useMutation18[0],
    editLeaveTypeLoading = _useMutation18[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var visibility, finalUserIds, variables, _response$data5, _response$data5$editL, response;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          visibility = isPriorityCheck ? "private" : "public";
          finalUserIds = visibility === "public" ? publicActive : userActive;
          variables = {
            organisationId: organisationId,
            leaveTypeId: leaveTypeId,
            leaveTypeVisibility: visibility,
            userId: finalUserIds || []
          };
          _context10.prev = 3;
          _context10.next = 6;
          return editLeaveMembers({
            variables: variables,
            awaitRefetchQueries: true,
            refetchQueries: [{
              query: LEAVE_SETTINGS_LIST_QUERY,
              variables: {
                organisationId: organisationId,
                limit: LIMIT,
                offset: 0
              }
            }]
          });
        case 6:
          response = _context10.sent;
          if (response !== null && response !== void 0 && (_response$data5 = response.data) !== null && _response$data5 !== void 0 && (_response$data5$editL = _response$data5.editLeaveTypesForMember) !== null && _response$data5$editL !== void 0 && _response$data5$editL.leaveTypeId) {
            _context10.next = 10;
            break;
          }
          toast.error("Error Occurred, Try again later!!!");
          return _context10.abrupt("return");
        case 10:
          setLeaveTypeEditList(function (prev) {
            return prev.map(function (item) {
              return item.leaveTypeId === leaveTypeId ? _objectSpread(_objectSpread({}, item), {}, {
                leaveTypeVisibility: visibility,
                leaveUser: visibility === "private" ? finalUserIds.map(function (id) {
                  return {
                    userId: id
                  };
                }) : []
              }) : item;
            });
          });
          toast.success("Member assignment updated successfully!");
          handleLeaveTypeEditClose();
          _context10.next = 19;
          break;
        case 15:
          _context10.prev = 15;
          _context10.t0 = _context10["catch"](3);
          console.error("Member update error:", _context10.t0); // ⭐ helpful debug
          toast.error("Error Occurred, Try again later!!!");
        case 19:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[3, 15]]);
  })), [organisationId, leaveTypeId, isPriorityCheck, userActive, publicActive, editLeaveMembers, setLeaveTypeEditList, handleLeaveTypeEditClose]);
  var handleKey = function handleKey(data) {
    setIsPriorityCheck(function (prev) {
      return prev === true ? false : true;
    });
    var t = userDetails === null || userDetails === void 0 ? void 0 : userDetails.map(function (user) {
      return user.userId;
    });
    setPublicActive(t);
  };
  var userWithSearch = function userWithSearch(userData) {
    if (!searchUser) {
      return userData;
    }
    return userData.filter(function (filterUsersData) {
      var _filterUsersData$disp5, _filterUsersData$disp6, _filterUsersData$disp7, _filterUsersData$disp8;
      return filterUsersData === null || filterUsersData === void 0 ? void 0 : (_filterUsersData$disp5 = filterUsersData.displayName) === null || _filterUsersData$disp5 === void 0 ? void 0 : (_filterUsersData$disp6 = _filterUsersData$disp5.toLowerCase) === null || _filterUsersData$disp6 === void 0 ? void 0 : (_filterUsersData$disp7 = _filterUsersData$disp6.call(_filterUsersData$disp5)) === null || _filterUsersData$disp7 === void 0 ? void 0 : (_filterUsersData$disp8 = _filterUsersData$disp7.includes) === null || _filterUsersData$disp8 === void 0 ? void 0 : _filterUsersData$disp8.call(_filterUsersData$disp7, searchUser.toLowerCase());
    });
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Accordion, {
    className: classNames("task-modal-accordion-whole task-editmoldal-accordion"),
    defaultActiveKey: !isPriorityCheck ? null : "0"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return handleKey("setting");
    }
  }, /*#__PURE__*/React.createElement(Accordion.Toggle, {
    as: Button,
    variant: "link",
    eventKey: "0",
    className: "task-modal-content-header-team-name-acc-edit"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-rule-uparrow toggle-switch"
  }, /*#__PURE__*/React.createElement("label", {
    "for": "chkTest"
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("toggle-track", {
      "toggle-track-nav-right-div": !isPriorityCheck
    })
  }))), /*#__PURE__*/React.createElement("span", {
    className: "project-detail-tasks-modal-content-header-setting-edit"
  }, /*#__PURE__*/React.createElement(HiLockClosed, {
    className: "project-tasks-modal-content-header-setting-icon"
  }), " Assign this leave type to all members"))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-edit-modal-content-person-name-header-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tasks-modal-content-person-name-header-section-label"
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("my-projects-modal-content-person-name-header-section-content", {
      "my-projects-modal-content-person-name-header-section-content--edit": isPriorityCheck
    })
  }, (userActive === null || userActive === void 0 ? void 0 : userActive.length) == (userIds === null || userIds === void 0 ? void 0 : userIds.length) ? /*#__PURE__*/React.createElement("p", {
    className: "projects-tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive([]);
      setUserSelected(false);
    }
  }, "Unselect All") : /*#__PURE__*/React.createElement("p", {
    //variant="outline-secondary"
    className: "projects-tasks-modal-content-person-name-header-button",
    onClick: function onClick() {
      setUserActive(userIds);
      setUserSelected(true);
    }
  }, "Select All"), /*#__PURE__*/React.createElement("div", {
    className: "my-projects-modal-searchbox-wrapper-edit"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    value: searchUser,
    onChange: setSearchUser,
    placeholder: "Search employee name"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classNames("project-details-tasks-modal-content-person-name-listing", {
      "project-details-tasks-modal-content-person-name-listing--edit": isPriorityCheck
    })
  }, usersLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetails && (_userWithSearch3 = userWithSearch(userDetails)) !== null && _userWithSearch3 !== void 0 && _userWithSearch3.length ? (_userWithSearch4 = userWithSearch(userDetails)) === null || _userWithSearch4 === void 0 ? void 0 : _userWithSearch4.map(function (user, index) {
    var teamFirstName = user.displayName.match(/\b(\w)/g);
    var teamNameIcon = teamFirstName.join("");
    return /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-person-name-listing-card-content",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-team-name"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: user.userId,
      name: "myRadioGroup",
      className: "create-project-team-selection-control-checkbox",
      checked: userActive.includes(user.userId),
      onChange: function onChange() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person",
      onClick: function onClick() {
        setUserSelected(true);
        setUserActive(function (prev) {
          return prev.includes(user.userId) ? prev.filter(function (a) {
            return a !== user.userId;
          }) : [].concat(_toConsumableArray(prev), [user.userId]);
        });
      }
    }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "task-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "Workfolio",
      src: user === null || user === void 0 ? void 0 : user.profileUrl,
      className: "task-card-avatar-profile-img"
    }))) : /*#__PURE__*/React.createElement("div", {
      className: "tasks-modal-content-person-name-listing-card-content-person-icon"
    }, user.displayName.charAt(0).toUpperCase()), /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-content-header-team-name--edit"
    }, user.displayName)));
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text-muted text-center"
  }, "No member found for \"".concat(searchUser, "\"")))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 12,
    md: 12,
    lg: 12
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("leave-settings-edit-root-modal-button text-center", {
      "leave-settings-modal-button-edit-private": isPriorityCheck
    })
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "leave-settings-modal-save-button",
    onClick: handleSubmit,
    disabled: editLeaveTypeLoading
  }, editLeaveTypeLoading ? "Loading..." : "Save Changes")))));
};
var CarryForward = function CarryForward(props) {
  var leaveTypeEditList = props.leaveTypeEditList,
    handleLeaveTypeEditClose = props.handleLeaveTypeEditClose,
    leaveTypeModalEditShow = props.leaveTypeModalEditShow,
    organisationId = props.organisationId,
    setLeaveTypeEditList = props.setLeaveTypeEditList;
  var leaveCarryForward = leaveTypeModalEditShow.leaveCarryForward,
    leaveTypeId = leaveTypeModalEditShow.leaveTypeId;
  var innerRef = useRef();
  var _useMutation19 = useMutation(EDIT_CARRY_FORWARD_MUTATION),
    _useMutation20 = _slicedToArray(_useMutation19, 2),
    editCarryForward = _useMutation20[0],
    editLeaveTypeLoading = _useMutation20[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(values, actions) {
      var carryForward, variables, _response$data6, response, updated;
      return _regeneratorRuntime().wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            carryForward = values.carryForward; // ✅ backend expects string "true"/"false"
            variables = {
              organisationId: organisationId,
              leaveTypeId: leaveTypeId,
              carryForward: carryForward ? "true" : "false"
            };
            _context11.prev = 2;
            _context11.next = 5;
            return editCarryForward({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 5:
            response = _context11.sent;
            actions.setSubmitting(false);
            if (response !== null && response !== void 0 && (_response$data6 = response.data) !== null && _response$data6 !== void 0 && _response$data6.editLeaveTypesForCarryForward) {
              _context11.next = 10;
              break;
            }
            toast.error("Error Occurred, Try again later!!!");
            return _context11.abrupt("return");
          case 10:
            updated = response.data.editLeaveTypesForCarryForward; // ✅ safe local update
            setLeaveTypeEditList(function (prev) {
              return prev.map(function (item) {
                return item.leaveTypeId === updated.leaveTypeId ? _objectSpread(_objectSpread({}, item), {}, {
                  leaveCarryForward: updated.leaveCarryForward
                }) : item;
              });
            });
            toast.success("Carry forward updated successfully!");
            actions.resetForm();
            handleLeaveTypeEditClose();
            _context11.next = 21;
            break;
          case 17:
            _context11.prev = 17;
            _context11.t0 = _context11["catch"](2);
            toast.error("Error Occurred, Try again later!!!");
            actions.setSubmitting(false);
          case 21:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[2, 17]]);
    }));
    return function (_x10, _x11) {
      return _ref21.apply(this, arguments);
    };
  }(), [organisationId, leaveTypeId]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      carryForward: leaveCarryForward == "true" ? true : false
    }
    //validationSchema={LeaveTypesSchema}
    ,
    onSubmit: handleSubmit
  }, function (_ref22) {
    var setFieldValue = _ref22.setFieldValue,
      values = _ref22.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("")
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Field, {
      as: Form.Check,
      name: "carryForward",
      checked: values.carryForward,
      label: "Enable leave carry forward",
      id: "cary-forward",
      className: "leave-type-edit-settingts-checkbox"
    }))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames("leave-settings-edit-root-modal-button text-center")
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "leave-settings-modal-save-button",
      type: "submit",
      disabled: editLeaveTypeLoading
    }, editLeaveTypeLoading ? "Loading..." : "Save Changes")))))));
  }));
};
var DeleteConfirmation = function DeleteConfirmation(props) {
  var leaveTypeModalDeleteShow = props.leaveTypeModalDeleteShow,
    handleLeaveTypeDeleteClose = props.handleLeaveTypeDeleteClose,
    setLeaveTypeDeleteList = props.setLeaveTypeDeleteList,
    leaveTypeDeleteList = props.leaveTypeDeleteList,
    organisationId = props.organisationId;
  if (leaveTypeModalDeleteShow == null) {
    return null;
  }
  var leaveTypeId = leaveTypeModalDeleteShow.leaveTypeId;
  var _useMutation21 = useMutation(DELETE_LEAVE_TYPES_MUTATION),
    _useMutation22 = _slicedToArray(_useMutation21, 2),
    deleteLeaveTypes = _useMutation22[0],
    deleting = _useMutation22[1].loading;
  var onDeleteSubmit = /*#__PURE__*/function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
      var variables, response, deleteUser;
      return _regeneratorRuntime().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (!deleting) {
              _context12.next = 2;
              break;
            }
            return _context12.abrupt("return");
          case 2:
            _context12.prev = 2;
            variables = {
              organisationId: organisationId,
              leaveTypeId: leaveTypeId
            };
            _context12.next = 6;
            return deleteLeaveTypes({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LEAVE_TYPE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 6:
            response = _context12.sent;
            if (response && response.data && response.data.deleteLeaveTypes !== "") {
              deleteUser = _toConsumableArray(leaveTypeDeleteList);
              deleteUser.push(response.data.deleteLeaveTypes.leaveTypeId);
              setLeaveTypeDeleteList(_toConsumableArray(deleteUser));
              handleLeaveTypeDeleteClose();
              toast.success("Leave deleted successfully!");
            }
            _context12.next = 13;
            break;
          case 10:
            _context12.prev = 10;
            _context12.t0 = _context12["catch"](2);
            toast.error("Error Occured, try again later !!!");
          case 13:
          case "end":
            return _context12.stop();
        }
      }, _callee12, null, [[2, 10]]);
    }));
    return function onDeleteSubmit() {
      return _ref23.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: leaveTypeModalDeleteShow,
    onHide: handleLeaveTypeDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Delete Leave Type")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to delete this leave type?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "You can't undo this action once you deleted this leave type.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleLeaveTypeDeleteClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onDeleteSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : "Delete")));
};
var ArchiveLeaveConfirmation = function ArchiveLeaveConfirmation(props) {
  var handleLeaveTypeArchiveClose = props.handleLeaveTypeArchiveClose,
    handleLeaveTypeArchiveShow = props.handleLeaveTypeArchiveShow,
    setleaveTypeArchiveShow = props.setleaveTypeArchiveShow,
    leaveTypeArchiveList = props.leaveTypeArchiveList,
    setLeaveTypeArchiveList = props.setLeaveTypeArchiveList,
    organisationId = props.organisationId,
    leaveTypeModalArchiveShow = props.leaveTypeModalArchiveShow,
    leaveTypeUnArchiveList = props.leaveTypeUnArchiveList,
    setLeaveTypeUnArchiveList = props.setLeaveTypeUnArchiveList;
  if (leaveTypeModalArchiveShow == null) {
    return null;
  }
  var leaveTypeId = leaveTypeModalArchiveShow.leaveTypeId,
    status = leaveTypeModalArchiveShow.status;
  var _useMutation23 = useMutation(UPDATE_LEAVE_TYPE_STATUS_MUTATION),
    _useMutation24 = _slicedToArray(_useMutation23, 2),
    archiveLeaveTypes = _useMutation24[0],
    deleting = _useMutation24[1].loading;
  var onArchiveSubmit = /*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!deleting) {
              _context13.next = 2;
              break;
            }
            return _context13.abrupt("return");
          case 2:
            _context13.prev = 2;
            variables = {
              organisationId: organisationId,
              leaveTypeId: leaveTypeId,
              leaveTypeStatus: status
            };
            _context13.next = 6;
            return archiveLeaveTypes({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: LEAVE_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LEAVE_TYPE_ARCHIVED_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }, {
                query: LEAVE_TYPE_LIST_COUNT_QUERY,
                variables: {
                  organisationId: organisationId
                }
              }]
            });
          case 6:
            response = _context13.sent;
            if (response && response.data && response.data.updateLeaveTypeStatus !== "") {
              if (status == "archived") {
                // let archivedUser = [...leaveTypeArchiveList];
                // archivedUser.push(response.data.updateLeaveTypeStatus.leaveTypeId);
                // setLeaveTypeArchiveList([...archivedUser]);
              } else {
                // let unarchivedUser = [...leaveTypeUnArchiveList];
                // unarchivedUser.push(response.data.updateLeaveTypeStatus.leaveTypeId);
                // setLeaveTypeUnArchiveList([...unarchivedUser]);
              }
              handleLeaveTypeArchiveClose();
              toast.success("Leave ".concat(status == "archived" ? "Archived" : "Unarchived", " successfully!"));
            }
            _context13.next = 13;
            break;
          case 10:
            _context13.prev = 10;
            _context13.t0 = _context13["catch"](2);
            //console.log({ err });
            toast.error("Error Occured, try again later !!!");
          case 13:
          case "end":
            return _context13.stop();
        }
      }, _callee13, null, [[2, 10]]);
    }));
    return function onArchiveSubmit() {
      return _ref24.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: leaveTypeModalArchiveShow,
    onHide: handleLeaveTypeArchiveClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "".concat(status == "archived" ? "Archive" : "Unarchive", " Leave Type"))), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to ".concat(status == "archived" ? "archive" : "unarchive", " this leave type?"))), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handleLeaveTypeArchiveClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onArchiveSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : status == "archived" ? "Archive" : "Unarchive")));
};
var LeavePermissionModal = function LeavePermissionModal(props) {
  var leavePermissionModalShow = props.leavePermissionModalShow,
    handleLeavePermissionClose = props.handleLeavePermissionClose,
    organisationId = props.organisationId,
    userId = props.userId,
    timeZone = props.timeZone;
  if (leavePermissionModalShow === null) {
    return null;
  }
  var _useMutation25 = useMutation(ADD_PERMISSION_DETAILS_MUTATION),
    _useMutation26 = _slicedToArray(_useMutation25, 2),
    addPermissionDetails = _useMutation26[0],
    addPermissionDetailsLoading = _useMutation26[1].loading;
  var handlePermissionSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(values, _ref25) {
      var resetForm, setFieldError, variables, response;
      return _regeneratorRuntime().wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            resetForm = _ref25.resetForm, setFieldError = _ref25.setFieldError;
            if (!(Number(values === null || values === void 0 ? void 0 : values.totalTime) <= 0)) {
              _context14.next = 4;
              break;
            }
            setFieldError("totalTime", "Please enter a value greater than 0.");
            return _context14.abrupt("return");
          case 4:
            variables = {
              userId: userId,
              organisationId: organisationId,
              permissionName: "Short Leave",
              //applicableWithin: values?.applicableWithin,
              applicableWithin: "month",
              totalAllowedTime: values !== null && values !== void 0 && values.totalTime ? Number(values === null || values === void 0 ? void 0 : values.totalTime) : 0
              // minTimePerRequest: values?.minTimePerRequest ? Number(values?.minTimePerRequest) : 0,
              // maxTimePerRequest: values?.maxTimePerRequest ? Number(values?.maxTimePerRequest) : 0,
              // totalAllowedRequest: values?.totalAllowedRequest ? Number(values?.totalAllowedRequest) : 0,
            };
            _context14.prev = 5;
            _context14.next = 8;
            return addPermissionDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PERMISSION_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 8:
            response = _context14.sent;
            if (response && response.data && response.data.addPermissionDetails == true) {
              toast.success("Short leave type added successfully!");
              //resetForm();
              handleLeavePermissionClose();
            } else {
              toast.error("Error Occured, try again!");
            }
            _context14.next = 15;
            break;
          case 12:
            _context14.prev = 12;
            _context14.t0 = _context14["catch"](5);
            toast.error("Error Occured, try again!");
          case 15:
          case "end":
            return _context14.stop();
        }
      }, _callee14, null, [[5, 12]]);
    }));
    return function (_x12, _x13) {
      return _ref26.apply(this, arguments);
    };
  }(), [addPermissionDetails, addPermissionDetailsLoading]);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handleLeavePermissionClose,
    size: "md",
    centered: true,
    className: "leave-setting-permission-modal-full-div"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, "Create Short Leave")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      //permissionName: "",
      //applicableWithin: "week",
      totalTime: ""
      // minTimePerRequest:" ",
      // maxTimePerRequest: " ",
      // totalAllowedRequest: " ",
    },
    validationSchema: permissionSchema,
    onSubmit: handlePermissionSubmit
  }, function (_ref27) {
    var setFieldValue = _ref27.setFieldValue,
      errors = _ref27.errors,
      touched = _ref27.touched,
      values = _ref27.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "leave-setting-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "leave-permission-modal-content-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-flef-row"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "totalTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Allowed short leave duration for a month period"), /*#__PURE__*/React.createElement("span", {
        className: "my-projects-modal-label-name-required"
      }, " *"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "short-leave-error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "my-project-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "my-project-add-new-project-hours-text"
      }, "Minutes")));
    })))), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-save-button",
      type: "submit",
      disabled: addPermissionDetailsLoading
    }, addPermissionDetailsLoading ? "Loading..." : "Create Short Leave"))))))));
  })));
};
var PermissionModalEdit = function PermissionModalEdit(props) {
  var permissionModalEditShow = props.permissionModalEditShow,
    handlePermissionEditClose = props.handlePermissionEditClose,
    userId = props.userId,
    organisationId = props.organisationId,
    permissionEditList = props.permissionEditList,
    setPermissionEditList = props.setPermissionEditList;
  if (permissionModalEditShow == null) {
    return null;
  }
  var innerRef = useRef();
  useEffect(function () {
    return innerRef.current && innerRef.current.focus();
  });
  var permissionName = permissionModalEditShow.permissionName,
    permissionId = permissionModalEditShow.permissionId,
    applicableWithin = permissionModalEditShow.applicableWithin,
    totalAllowedTimeInMin = permissionModalEditShow.totalAllowedTimeInMin;
  var _useMutation27 = useMutation(EDIT_PERMISSION_DETAILS_MUTATION),
    _useMutation28 = _slicedToArray(_useMutation27, 2),
    editPermissionDetails = _useMutation28[0],
    editPermissionLoading = _useMutation28[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(values, actions) {
      var variables, editLeaveTypesResponse, editLeave;
      return _regeneratorRuntime().wrap(function _callee15$(_context15) {
        while (1) switch (_context15.prev = _context15.next) {
          case 0:
            if (!(Number(values === null || values === void 0 ? void 0 : values.totalTime) <= 0)) {
              _context15.next = 3;
              break;
            }
            actions.setFieldError("totalTime", "Please enter a value greater than 0.");
            return _context15.abrupt("return");
          case 3:
            variables = {
              userId: userId,
              organisationId: organisationId,
              permissionName: "Short Leave",
              //applicableWithin: values?.applicableWithin,
              applicableWithin: "month",
              totalAllowedTime: values !== null && values !== void 0 && values.totalTime ? Number(values === null || values === void 0 ? void 0 : values.totalTime) : 0,
              // minTimePerRequest: values?.minTimePerRequest ? Number(values?.minTimePerRequest) : 0,
              // maxTimePerRequest: values?.maxTimePerRequest ? Number(values?.maxTimePerRequest) : 0,
              // totalAllowedRequest: values?.totalAllowedRequest ? Number(values?.totalAllowedRequest) : 0,
              permissionId: permissionId
            };
            _context15.prev = 4;
            _context15.next = 7;
            return editPermissionDetails({
              variables: variables,
              refetchQueries: [{
                query: PERMISSION_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 7:
            editLeaveTypesResponse = _context15.sent;
            // Resets form after submission is complete
            actions.resetForm();
            actions.setSubmitting(false);
            if (!editLeaveTypesResponse || !editLeaveTypesResponse.data || editLeaveTypesResponse.data.editPermissionDetails == false) {
              toast.error("Error Occurred, Try again later!!!");
            } else {
              editLeave = _toConsumableArray(permissionEditList);
              editLeave.push(_objectSpread({}, editLeaveTypesResponse.data.editPermissionDetails));
              setPermissionEditList(_toConsumableArray(editLeave));
              toast.success("Short leave type updated successfully!");
              handlePermissionEditClose();
            }
            _context15.next = 17;
            break;
          case 13:
            _context15.prev = 13;
            _context15.t0 = _context15["catch"](4);
            toast.error("Error Occurred, Try again later!!!");
            actions.setSubmitting(false);
          case 17:
          case "end":
            return _context15.stop();
        }
      }, _callee15, null, [[4, 13]]);
    }));
    return function (_x14, _x15) {
      return _ref28.apply(this, arguments);
    };
  }(), []);
  return /*#__PURE__*/React.createElement(Modal, {
    show: true,
    onHide: handlePermissionEditClose,
    centered: true,
    className: "leave-setting-permission-modal-full-div"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-modal-title"
  }, "Edit Short Leave ")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      // permissionName: permissionName,
      //applicableWithin: applicableWithin ? applicableWithin : "week",
      totalTime: totalAllowedTimeInMin ? totalAllowedTimeInMin : ""
      // minTimePerRequest: minTimePerRequestInMin ? minTimePerRequestInMin: " ",
      // maxTimePerRequest: maxTimePerRequestInMin ? maxTimePerRequestInMin: " ",
      // totalAllowedRequest: totalAllowedRequest ? totalAllowedRequest: " ",
    },
    validationSchema: permissionSchema,
    onSubmit: handleSubmit
  }, function (_ref29) {
    var setFieldValue = _ref29.setFieldValue,
      values = _ref29.values;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "leave-setting-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
      className: "leave-permission-modal-content-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "leave-setting-flef-row"
    }, /*#__PURE__*/React.createElement(Field, {
      name: "totalTime"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "edit-user-details-list-modal-content-name-field"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "my-projects-modal-label-name"
      }, "Allowed short leave duration for a month period"), /*#__PURE__*/React.createElement("span", {
        className: "my-projects-modal-label-name-required"
      }, " *"), meta.error && meta.touched ? /*#__PURE__*/React.createElement("div", {
        className: "short-leave-error"
      }, meta.error) : null, /*#__PURE__*/React.createElement("div", {
        className: "my-project-add-new-project-option-div"
      }, /*#__PURE__*/React.createElement(FormControl, _extends({
        type: "Number",
        placeholder: "Enter the value in minutes",
        className: "edit-user-details-list-modal-input",
        min: "0",
        onKeyPress: function onKeyPress(event) {
          if (event.charCode < 48) {
            event.preventDefault();
          }
        }
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "my-project-add-new-project-hours-text"
      }, "Minutes")));
    })))), /*#__PURE__*/React.createElement(Row, {
      className: "add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "my-projects-modal-save-button",
      type: "submit",
      disabled: editPermissionLoading
    }, editPermissionLoading ? "Loading..." : "Update Short Leave"))))))));
  })));
};
var PermissionDeleteConfirmation = function PermissionDeleteConfirmation(props) {
  var permissionModalDeleteShow = props.permissionModalDeleteShow,
    handlePermissionDeleteClose = props.handlePermissionDeleteClose,
    setPermissionDeleteList = props.setPermissionDeleteList,
    permissionDeleteList = props.permissionDeleteList,
    organisationId = props.organisationId,
    userId = props.userId;
  if (permissionModalDeleteShow == null) {
    return null;
  }
  var permissionId = permissionModalDeleteShow.permissionId;
  var _useMutation29 = useMutation(DELETE_PERMISSION_DETAILS_MUTATION),
    _useMutation30 = _slicedToArray(_useMutation29, 2),
    deletePermissionDetails = _useMutation30[0],
    deleting = _useMutation30[1].loading;
  var onDeleteSubmit = /*#__PURE__*/function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
      var variables, response, deleteUser;
      return _regeneratorRuntime().wrap(function _callee16$(_context16) {
        while (1) switch (_context16.prev = _context16.next) {
          case 0:
            if (!deleting) {
              _context16.next = 2;
              break;
            }
            return _context16.abrupt("return");
          case 2:
            _context16.prev = 2;
            variables = {
              organisationId: organisationId,
              permissionId: permissionId
            };
            _context16.next = 6;
            return deletePermissionDetails({
              variables: variables,
              awaitRefetchQueries: true,
              refetchQueries: [{
                query: PERMISSION_SETTINGS_LIST_QUERY,
                variables: {
                  organisationId: organisationId,
                  limit: LIMIT,
                  offset: 0
                }
              }]
            });
          case 6:
            response = _context16.sent;
            if (response && response.data && response.data.deletePermissionDetails !== "") {
              deleteUser = _toConsumableArray(permissionDeleteList);
              deleteUser.push(response.data.deletePermissionDetails.permissionId);
              setPermissionDeleteList(_toConsumableArray(deleteUser));
              handlePermissionDeleteClose();
              toast.success("Short leave deleted successfully!");
            }
            _context16.next = 13;
            break;
          case 10:
            _context16.prev = 10;
            _context16.t0 = _context16["catch"](2);
            toast.error("Error Occured, try again later !!!");
          case 13:
          case "end":
            return _context16.stop();
        }
      }, _callee16, null, [[2, 10]]);
    }));
    return function onDeleteSubmit() {
      return _ref30.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Modal, {
    show: permissionModalDeleteShow,
    onHide: handlePermissionDeleteClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "project-details-task-card-delete-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "project-details-task-card-delete-title"
  }, "Disable Short Leave")), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "project-details-task-card-delete-body"
  }, " ", /*#__PURE__*/React.createElement("h6", {
    className: "font-weight-bold mb-2"
  }, "Are you sure to disable short leave option?"), /*#__PURE__*/React.createElement("p", {
    className: "text-secondary"
  }, "Later you can enable the short leave option whenever it's required.")), /*#__PURE__*/React.createElement(Modal.Footer, null, /*#__PURE__*/React.createElement(Button, {
    variant: "outline-secondary",
    className: "project-details-task-card-delete-cancel-button",
    onClick: function onClick() {
      return handlePermissionDeleteClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "danger",
    className: "project-details-task-card-delete-button",
    onClick: function onClick() {
      onDeleteSubmit();
    },
    disabled: deleting
  }, deleting ? "Loading..." : "Disable Short Leave")));
};
var PermissionDetailsModal = function PermissionDetailsModal(props) {
  var showPermissionDetailModal = props.showPermissionDetailModal,
    handleClosePermissionDetailDetails = props.handleClosePermissionDetailDetails;
  if (showPermissionDetailModal == null) {
    return null;
  }
  var permissionName = showPermissionDetailModal.permissionName,
    permissionId = showPermissionDetailModal.permissionId,
    applicableWithin = showPermissionDetailModal.applicableWithin,
    totalAllowedTimeInSec = showPermissionDetailModal.totalAllowedTimeInSec,
    totalAllowedTime = showPermissionDetailModal.totalAllowedTime,
    totalAllowedTimeInMin = showPermissionDetailModal.totalAllowedTimeInMin,
    minTimePerRequestInSec = showPermissionDetailModal.minTimePerRequestInSec,
    minTimePerRequest = showPermissionDetailModal.minTimePerRequest,
    minTimePerRequestInMin = showPermissionDetailModal.minTimePerRequestInMin,
    maxTimePerRequestInSec = showPermissionDetailModal.maxTimePerRequestInSec,
    maxTimePerRequest = showPermissionDetailModal.maxTimePerRequest,
    maxTimePerRequestInMin = showPermissionDetailModal.maxTimePerRequestInMin,
    totalAllowedRequest = showPermissionDetailModal.totalAllowedRequest;
  return /*#__PURE__*/React.createElement(Modal, {
    show: showPermissionDetailModal,
    onHide: handleClosePermissionDetailDetails,
    centered: true,
    size: "lg",
    className: "task-tracker-task-detail-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "task-tracker-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-tracker-task-detail-modal-title"
  }, permissionName)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "task-overview-detail-modal-body-permission "
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-modal-body-div"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-summary"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Applicable Within"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, applicableWithin)), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Total Allowed Time"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, totalAllowedTime)), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Minimum Time Per Request"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, minTimePerRequest)), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Maximum Time Per Request"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, maxTimePerRequest)), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Total Allowed Request"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, totalAllowedRequest))))));
};
var ViewDetailsModal = function ViewDetailsModal(props) {
  var leaveTypeViewShow = props.leaveTypeViewShow,
    handleLeaveTypeViewClose = props.handleLeaveTypeViewClose,
    organisationId = props.organisationId;
  if (leaveTypeViewShow == null) {
    return null;
  }
  var leaveTypeName = leaveTypeViewShow.leaveTypeName,
    leaveTypeCount = leaveTypeViewShow.leaveTypeCount,
    resetLeaveBalance = leaveTypeViewShow.resetLeaveBalance,
    leaveCarryForward = leaveTypeViewShow.leaveCarryForward,
    leaveTypeVisibility = leaveTypeViewShow.leaveTypeVisibility,
    leaveUser = leaveTypeViewShow.leaveUser,
    leaveNature = leaveTypeViewShow.leaveNature,
    addedBy = leaveTypeViewShow.addedBy,
    addedAt = leaveTypeViewShow.addedAt,
    updatedBy = leaveTypeViewShow.updatedBy,
    updatedAt = leaveTypeViewShow.updatedAt,
    leaveTypeId = leaveTypeViewShow.leaveTypeId;
  var _useLazyQuery3 = useLazyQuery(LEAVE_ACTIVITY_SUMMARY_QUERY, {
      fetchPolicy: "network-only"
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getleaveActivitySummary = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    leaveActivitySummaryData = _useLazyQuery4$.data,
    leaveActivitySummaryError = _useLazyQuery4$.error,
    leaveActivitySummaryLoading = _useLazyQuery4$.loading,
    leaveActivitySummaryFetchMore = _useLazyQuery4$.fetchMore;
  var _React$useState63 = React.useState("leave-details"),
    _React$useState64 = _slicedToArray(_React$useState63, 2),
    leaveViewActiveTab = _React$useState64[0],
    setLeaveViewActiveTab = _React$useState64[1];
  var handleTabSelect = function handleTabSelect(key) {
    setLeaveViewActiveTab(key);
    if (key === "activity-history") {
      getleaveActivitySummary({
        variables: {
          organisationId: organisationId,
          leaveTypeId: leaveTypeId,
          limit: TASK_ACTIVITY_LIMIT,
          offset: 0
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: leaveTypeViewShow,
    onHide: handleLeaveTypeViewClose,
    centered: true,
    size: "lg",
    className: "task-tracker-task-detail-modal leave-type-view-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "task-tracker-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-tracker-task-detail-modal-title"
  }, leaveTypeName)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "leave-view-detail-modal-body "
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-modal-body-div"
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultActiveKey: "leave-details",
    className: "task-header-menu-whole-div-content-whole-filter-content-div-table-view-modal leave-view-modal-tabs",
    onSelect: function onSelect(e) {
      handleTabSelect(e);
    }
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "leave-details",
    title: "Leave Details"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-details-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Allowed Days "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(FiCalendar, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, leaveTypeCount, " ", leaveTypeCount || leaveTypeCount == 0 ? leaveTypeCount > 1 ? "days" : "day" : "Unlimited days"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Leave Cycle "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(BsArrowLeftRight, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, resetLeaveBalance ? resetLeaveBalance : "Annually"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Carry Forward "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, leaveCarryForward == "true" ? /*#__PURE__*/React.createElement(FiCheck, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }) : /*#__PURE__*/React.createElement(FiSlash, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, leaveCarryForward == "true" ? "Yes" : "No"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Paid/Unpaid "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, leaveNature == "Unpaid" ? /*#__PURE__*/React.createElement(MdMoneyOff, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }) : /*#__PURE__*/React.createElement(FiDollarSign, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, leaveNature ? leaveNature == "Paid" ? "Paid Leave" : "Unpaid Leave" : "Paid Leave"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, "Visibility "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, leaveTypeVisibility == "private" ? /*#__PURE__*/React.createElement(FiLock, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }) : /*#__PURE__*/React.createElement(FiUnlock, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, leaveTypeVisibility == "private" ? "Selected Members" : " All Employees"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Created by "), addedBy ? /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(BsPerson, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, addedBy ? addedBy : "-")) : /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, addedBy ? addedBy : "-"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Created at "), addedAt ? /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(BsClock, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, addedAt ? moment(Number(addedAt)).format("DD/MM/yyyy hh:mm a") : "-")) : /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, addedAt ? moment(Number(addedAt)).format("DD/MM/yyyy hh:mm a") : "-"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Last modified by "), updatedBy ? /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(BsPerson, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, updatedBy ? updatedBy : "-")) : /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, updatedBy ? updatedBy : "-"))), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, " Last modified at "), updatedAt ? /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement(BsClock, {
    className: "leave-view-modal-content-whole-div-content-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, updatedAt ? moment(Number(updatedAt)).format("DD/MM/yyyy hh:mm a") : "-")) : /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-content"
  }, updatedAt ? moment(Number(updatedAt)).format("DD/MM/yyyy hh:mm a") : "-"))), leaveTypeVisibility == "private" ? /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-whole leave-view-modal-content-span-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header"
  }, "Leave Type Visible To", " ", /*#__PURE__*/React.createElement("span", null, "(", leaveUser.length, " Employees)"), " "), /*#__PURE__*/React.createElement("div", {
    className: "leave-view-modal-content-whole-div-header-content-emp"
  }, leaveUser === null || leaveUser === void 0 ? void 0 : leaveUser.map(function (employeeData, key) {
    var _employeeData$display;
    return /*#__PURE__*/React.createElement("div", {
      className: "leave-view-modal-content-whole-div-header-content"
    }, (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === null || (employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-card-avatar"
    }, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$display = employeeData.displayName) === null || _employeeData$display === void 0 ? void 0 : _employeeData$display.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
      className: "project-details-task-detail-card-avatar-profile"
    }, /*#__PURE__*/React.createElement("img", {
      alt: "DeskTime",
      src: employeeData === null || employeeData === void 0 ? void 0 : employeeData.profileUrl,
      className: "project-details-task-detail-card-avatar-profile-img"
    })), /*#__PURE__*/React.createElement("p", {
      className: "leave-view-modal-content-whole-div-content-p"
    }, employeeData === null || employeeData === void 0 ? void 0 : employeeData.displayName));
  }))) : null), /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "activity-history",
    title: "Activity History"
  }, /*#__PURE__*/React.createElement("div", {
    className: "leave-view-activity-history-scroll"
  }, /*#__PURE__*/React.createElement(ActivityHistory, {
    leaveActivitySummaryData: leaveActivitySummaryData,
    leaveActivitySummaryLoading: leaveActivitySummaryLoading,
    leaveActivitySummaryFetchMore: leaveActivitySummaryFetchMore
  })))))));
};
var TimelineItem = function TimelineItem(props) {
  var _data$displayName;
  var data = props.data,
    key = props.key;
  var displayName = data === null || data === void 0 ? void 0 : data.displayName;
  var activityData = (data === null || data === void 0 ? void 0 : data.activityData) || "";
  var hasNamePrefix = displayName && activityData.startsWith(displayName);
  var restOfMessage = hasNamePrefix ? activityData.slice(displayName.length) : activityData;
  return /*#__PURE__*/React.createElement("div", {
    className: "timeline-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeline-item-content"
  }, /*#__PURE__*/React.createElement("time", null, " ", moment.unix(data.createdAt / 1000).format("MMMM DD YYYY, hh:mm A")), /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-activity-history-event-text"
  }, (data === null || data === void 0 ? void 0 : data.profileUrl) === null || (data === null || data === void 0 ? void 0 : data.profileUrl) === "" ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-activity-history-card-avatar"
  }, data === null || data === void 0 ? void 0 : (_data$displayName = data.displayName) === null || _data$displayName === void 0 ? void 0 : _data$displayName.charAt(0).toUpperCase()) : /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-activity-history-card-avatar-profile"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "DeskTime",
    src: data === null || data === void 0 ? void 0 : data.profileUrl,
    className: "project-details-task-activity-history-card-avatar-profile-img"
  })), hasNamePrefix ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-activity-history-event-text-name"
  }, displayName), /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-activity-history-event-text-content"
  }, restOfMessage)) : /*#__PURE__*/React.createElement("span", {
    className: "project-details-task-activity-history-event-text-content"
  }, activityData)), /*#__PURE__*/React.createElement("span", {
    className: "circle"
  })));
};
var ActivityHistory = function ActivityHistory(props) {
  var _leaveActivitySummary4, _leaveActivitySummary5;
  var leaveActivitySummaryData = props.leaveActivitySummaryData,
    leaveActivitySummaryLoading = props.leaveActivitySummaryLoading,
    leaveActivitySummaryFetchMore = props.leaveActivitySummaryFetchMore;
  var _React$useState65 = React.useState(true),
    _React$useState66 = _slicedToArray(_React$useState65, 2),
    isAllLoadedActivity = _React$useState66[0],
    setIsAllLoadedActivity = _React$useState66[1];
  var _React$useState67 = React.useState(false),
    _React$useState68 = _slicedToArray(_React$useState67, 2),
    isLoadingMoreActivity = _React$useState68[0],
    setIsLoadingMoreActivity = _React$useState68[1];
  React.useEffect(function () {
    var _leaveActivitySummary, _leaveActivitySummary2;
    setIsAllLoadedActivity((leaveActivitySummaryData === null || leaveActivitySummaryData === void 0 ? void 0 : (_leaveActivitySummary = leaveActivitySummaryData.leaveTypeSettingSummary) === null || _leaveActivitySummary === void 0 ? void 0 : _leaveActivitySummary.length) != 0 && (leaveActivitySummaryData === null || leaveActivitySummaryData === void 0 ? void 0 : (_leaveActivitySummary2 = leaveActivitySummaryData.leaveTypeSettingSummary) === null || _leaveActivitySummary2 === void 0 ? void 0 : _leaveActivitySummary2.length) < TASK_ACTIVITY_LIMIT ? true : false);
  }, [leaveActivitySummaryData]);
  var handleLoadMore = function handleLoadMore() {
    var _leaveActivitySummary3;
    if (leaveActivitySummaryLoading) return;
    setIsLoadingMoreActivity(true);
    leaveActivitySummaryFetchMore({
      variables: {
        offset: (leaveActivitySummaryData === null || leaveActivitySummaryData === void 0 ? void 0 : (_leaveActivitySummary3 = leaveActivitySummaryData.leaveTypeSettingSummary) === null || _leaveActivitySummary3 === void 0 ? void 0 : _leaveActivitySummary3.length) + 1
      },
      updateQuery: function updateQuery(prev, _ref31) {
        var _fetchMoreResult$leav, _fetchMoreResult$leav2;
        var fetchMoreResult = _ref31.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$leav = fetchMoreResult.leaveTypeSettingSummary) === null || _fetchMoreResult$leav === void 0 ? void 0 : _fetchMoreResult$leav.length) === 0 && ((_fetchMoreResult$leav2 = fetchMoreResult.leaveTypeSettingSummary) === null || _fetchMoreResult$leav2 === void 0 ? void 0 : _fetchMoreResult$leav2.length) < TASK_ACTIVITY_LIMIT && !isAllLoadedActivity) {
          setIsAllLoadedActivity(true);
        }
        setIsLoadingMoreActivity(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          leaveTypeSettingSummary: [].concat(_toConsumableArray(prev.leaveTypeSettingSummary), _toConsumableArray(fetchMoreResult.leaveTypeSettingSummary))
        });
      }
    });
  };
  return leaveActivitySummaryLoading && !isLoadingMoreActivity ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : (leaveActivitySummaryData === null || leaveActivitySummaryData === void 0 ? void 0 : leaveActivitySummaryData.leaveTypeSettingSummary.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "timeline-container"
  }, leaveActivitySummaryData === null || leaveActivitySummaryData === void 0 ? void 0 : (_leaveActivitySummary4 = leaveActivitySummaryData.leaveTypeSettingSummary) === null || _leaveActivitySummary4 === void 0 ? void 0 : _leaveActivitySummary4.map(function (data, idx) {
    return /*#__PURE__*/React.createElement(TimelineItem, {
      data: data,
      key: idx
    });
  }), leaveActivitySummaryData !== null && leaveActivitySummaryData !== void 0 && (_leaveActivitySummary5 = leaveActivitySummaryData.leaveTypeSettingSummary) !== null && _leaveActivitySummary5 !== void 0 && _leaveActivitySummary5.length ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, !isAllLoadedActivity ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMoreActivity ? /*#__PURE__*/React.createElement("div", {
    className: "project-details-task-timeline-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "project-details-task-timeline-load-more-button project-management-miled-color"
  }, "You have seen all the activity")) : null) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    colspan: "3",
    className: "text-center employee-no-data "
  }, "No data found !!!"));
};
export default LeaveSettings;